/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as PolitiqueConfidentialiteRouteImport } from './routes/politique-confidentialite'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthSetupPasswordRouteImport } from './routes/_auth/setup-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppStockRouteRouteImport } from './routes/_app/stock/route'
import { Route as AppRhRouteRouteImport } from './routes/_app/rh/route'
import { Route as AppParametresRouteRouteImport } from './routes/_app/parametres/route'
import { Route as AppCreationRouteRouteImport } from './routes/_app/creation/route'
import { Route as AppAchatsRouteRouteImport } from './routes/_app/achats/route'
import { Route as AppdashboardRouteRouteImport } from './routes/_app/(dashboard)/route'
import { Route as AppStockIndexRouteImport } from './routes/_app/stock/index'
import { Route as AppRhIndexRouteImport } from './routes/_app/rh/index'
import { Route as AppCreationIndexRouteImport } from './routes/_app/creation/index'
import { Route as AppAchatsIndexRouteImport } from './routes/_app/achats/index'
import { Route as AppdashboardIndexRouteImport } from './routes/_app/(dashboard)/index'
import { Route as AuthSignatureContratTokenRouteImport } from './routes/_auth/signature-contrat/$token'
import { Route as AuthPointageQrCodeRouteImport } from './routes/_auth/pointage/qr-code'
import { Route as AuthPointageHashRouteImport } from './routes/_auth/pointage/$hash'
import { Route as AppStockMouvementsRouteRouteImport } from './routes/_app/stock/mouvements/route'
import { Route as AppStockInventairesRouteRouteImport } from './routes/_app/stock/inventaires/route'
import { Route as AppStockEmplacementsRouteRouteImport } from './routes/_app/stock/emplacements/route'
import { Route as AppStockDepotsRouteRouteImport } from './routes/_app/stock/depots/route'
import { Route as AppStockConsultationRouteRouteImport } from './routes/_app/stock/consultation/route'
import { Route as AppRhPlanningRouteRouteImport } from './routes/_app/rh/planning/route'
import { Route as AppRhFeuillesDeTempsRouteRouteImport } from './routes/_app/rh/feuilles-de-temps/route'
import { Route as AppRhDocumentsRouteRouteImport } from './routes/_app/rh/documents/route'
import { Route as AppRhContratsRouteRouteImport } from './routes/_app/rh/contrats/route'
import { Route as AppRhCongesRouteRouteImport } from './routes/_app/rh/conges/route'
import { Route as AppRhCompetencesRouteRouteImport } from './routes/_app/rh/competences/route'
import { Route as AppRhCollaborateursRouteRouteImport } from './routes/_app/rh/collaborateurs/route'
import { Route as AppCreationUniversCommerciauxRouteRouteImport } from './routes/_app/creation/univers-commerciaux/route'
import { Route as AppCreationPrestationsRouteRouteImport } from './routes/_app/creation/prestations/route'
import { Route as AppCreationPostesRouteRouteImport } from './routes/_app/creation/postes/route'
import { Route as AppCreationLdfRouteRouteImport } from './routes/_app/creation/ldf/route'
import { Route as AppCreationFamilleArticlesRouteRouteImport } from './routes/_app/creation/familleArticles/route'
import { Route as AppCreationDossierTechniquesRouteRouteImport } from './routes/_app/creation/dossier-techniques/route'
import { Route as AppCreationAteliersRouteRouteImport } from './routes/_app/creation/ateliers/route'
import { Route as AppCreationArticlesRouteRouteImport } from './routes/_app/creation/articles/route'
import { Route as AppStockMouvementsIndexRouteImport } from './routes/_app/stock/mouvements/index'
import { Route as AppStockInventairesIndexRouteImport } from './routes/_app/stock/inventaires/index'
import { Route as AppStockEmplacementsIndexRouteImport } from './routes/_app/stock/emplacements/index'
import { Route as AppStockConsultationIndexRouteImport } from './routes/_app/stock/consultation/index'
import { Route as AppRhPlanningIndexRouteImport } from './routes/_app/rh/planning/index'
import { Route as AppRhNotesDeFraisIndexRouteImport } from './routes/_app/rh/notes-de-frais/index'
import { Route as AppRhFeuillesDeTempsIndexRouteImport } from './routes/_app/rh/feuilles-de-temps/index'
import { Route as AppRhDocumentsIndexRouteImport } from './routes/_app/rh/documents/index'
import { Route as AppRhContratsIndexRouteImport } from './routes/_app/rh/contrats/index'
import { Route as AppRhCongesIndexRouteImport } from './routes/_app/rh/conges/index'
import { Route as AppRhCompetencesIndexRouteImport } from './routes/_app/rh/competences/index'
import { Route as AppRhCollaborateursIndexRouteImport } from './routes/_app/rh/collaborateurs/index'
import { Route as AppCreationUniversCommerciauxIndexRouteImport } from './routes/_app/creation/univers-commerciaux/index'
import { Route as AppCreationPrestationsIndexRouteImport } from './routes/_app/creation/prestations/index'
import { Route as AppCreationPostesIndexRouteImport } from './routes/_app/creation/postes/index'
import { Route as AppCreationLdfIndexRouteImport } from './routes/_app/creation/ldf/index'
import { Route as AppCreationFamilleArticlesIndexRouteImport } from './routes/_app/creation/familleArticles/index'
import { Route as AppCreationDossierTechniquesIndexRouteImport } from './routes/_app/creation/dossier-techniques/index'
import { Route as AppCreationAteliersIndexRouteImport } from './routes/_app/creation/ateliers/index'
import { Route as AppCreationArticlesIndexRouteImport } from './routes/_app/creation/articles/index'
import { Route as AppAchatsReceptionsIndexRouteImport } from './routes/_app/achats/receptions/index'
import { Route as AppAchatsFournituresIndexRouteImport } from './routes/_app/achats/fournitures/index'
import { Route as AppAchatsFournisseursIndexRouteImport } from './routes/_app/achats/fournisseurs/index'
import { Route as AppAchatsFacturesIndexRouteImport } from './routes/_app/achats/factures/index'
import { Route as AppAchatsCommandesIndexRouteImport } from './routes/_app/achats/commandes/index'
import { Route as AppdashboardProfileIndexRouteImport } from './routes/_app/(dashboard)/profile/index'
import { Route as AppdashboardMesCongesIndexRouteImport } from './routes/_app/(dashboard)/mes-conges/index'
import { Route as AppdashboardFraisIndexRouteImport } from './routes/_app/(dashboard)/frais/index'
import { Route as AppStockMouvementsCreateRouteImport } from './routes/_app/stock/mouvements/create'
import { Route as AppStockInventairesCreateRouteImport } from './routes/_app/stock/inventaires/create'
import { Route as AppStockEmplacementsCreateRouteImport } from './routes/_app/stock/emplacements/create'
import { Route as AppStockDepotsCreateRouteImport } from './routes/_app/stock/depots/create'
import { Route as AppRhPlanningCreateRouteImport } from './routes/_app/rh/planning/create'
import { Route as AppRhNotesDeFraisCreateRouteImport } from './routes/_app/rh/notes-de-frais/create'
import { Route as AppRhContratsCreateRouteImport } from './routes/_app/rh/contrats/create'
import { Route as AppRhCongesCreateRouteImport } from './routes/_app/rh/conges/create'
import { Route as AppRhCollaborateursCreateRouteImport } from './routes/_app/rh/collaborateurs/create'
import { Route as AppCreationUniversCommerciauxCreateRouteImport } from './routes/_app/creation/univers-commerciaux/create'
import { Route as AppCreationPrestationsCreateRouteImport } from './routes/_app/creation/prestations/create'
import { Route as AppCreationPostesCreateRouteImport } from './routes/_app/creation/postes/create'
import { Route as AppCreationLdfCreateRouteImport } from './routes/_app/creation/ldf/create'
import { Route as AppCreationFamilleArticlesCreateRouteImport } from './routes/_app/creation/familleArticles/create'
import { Route as AppCreationDossierTechniquesCreateRouteImport } from './routes/_app/creation/dossier-techniques/create'
import { Route as AppCreationAteliersCreateRouteImport } from './routes/_app/creation/ateliers/create'
import { Route as AppCreationArticlesCreateRouteImport } from './routes/_app/creation/articles/create'
import { Route as AppdashboardFraisCreateRouteImport } from './routes/_app/(dashboard)/frais/create'
import { Route as AppRhCollaborateursIdIndexRouteImport } from './routes/_app/rh/collaborateurs/$id/index'
import { Route as AppdashboardPointageMeIndexRouteImport } from './routes/_app/(dashboard)/pointage/me/index'
import { Route as AppdashboardPlanningMeIndexRouteImport } from './routes/_app/(dashboard)/planning/me/index'
import { Route as AppdashboardFraisMeIndexRouteImport } from './routes/_app/(dashboard)/frais/me/index'
import { Route as AppdashboardDocumentsMeIndexRouteImport } from './routes/_app/(dashboard)/documents/me/index'
import { Route as AppdashboardContratsMeIndexRouteImport } from './routes/_app/(dashboard)/contrats/me/index'
import { Route as AppdashboardCongesMeIndexRouteImport } from './routes/_app/(dashboard)/conges/me/index'
import { Route as AppStockMouvementsIdViewRouteImport } from './routes/_app/stock/mouvements/$id/view'
import { Route as AppStockMouvementsIdEditRouteImport } from './routes/_app/stock/mouvements/$id/edit'
import { Route as AppStockInventairesIdViewRouteImport } from './routes/_app/stock/inventaires/$id/view'
import { Route as AppStockInventairesIdEditRouteImport } from './routes/_app/stock/inventaires/$id/edit'
import { Route as AppStockEmplacementsIdViewRouteImport } from './routes/_app/stock/emplacements/$id/view'
import { Route as AppStockEmplacementsIdEditRouteImport } from './routes/_app/stock/emplacements/$id/edit'
import { Route as AppStockDepotsIdViewRouteImport } from './routes/_app/stock/depots/$id/view'
import { Route as AppStockDepotsIdEditRouteImport } from './routes/_app/stock/depots/$id/edit'
import { Route as AppRhPlanningIdViewRouteImport } from './routes/_app/rh/planning/$id/view'
import { Route as AppRhPlanningIdEditRouteImport } from './routes/_app/rh/planning/$id/edit'
import { Route as AppRhNotesDeFraisIdViewRouteImport } from './routes/_app/rh/notes-de-frais/$id/view'
import { Route as AppRhContratsIdViewRouteImport } from './routes/_app/rh/contrats/$id/view'
import { Route as AppRhContratsIdEditRouteImport } from './routes/_app/rh/contrats/$id/edit'
import { Route as AppRhCongesDemandesNewRouteImport } from './routes/_app/rh/conges/demandes/new'
import { Route as AppRhCongesIdViewRouteImport } from './routes/_app/rh/conges/$id/view'
import { Route as AppRhCollaborateursIdEditRouteImport } from './routes/_app/rh/collaborateurs/$id/edit'
import { Route as AppCreationUniversCommerciauxIdViewRouteImport } from './routes/_app/creation/univers-commerciaux/$id/view'
import { Route as AppCreationUniversCommerciauxIdEditRouteImport } from './routes/_app/creation/univers-commerciaux/$id/edit'
import { Route as AppCreationPrestationsIdViewRouteImport } from './routes/_app/creation/prestations/$id/view'
import { Route as AppCreationPrestationsIdEditRouteImport } from './routes/_app/creation/prestations/$id/edit'
import { Route as AppCreationPostesIdViewRouteImport } from './routes/_app/creation/postes/$id/view'
import { Route as AppCreationPostesIdEditRouteImport } from './routes/_app/creation/postes/$id/edit'
import { Route as AppCreationLdfIdViewRouteImport } from './routes/_app/creation/ldf/$id/view'
import { Route as AppCreationLdfIdEditRouteImport } from './routes/_app/creation/ldf/$id/edit'
import { Route as AppCreationFamilleArticlesIdViewRouteImport } from './routes/_app/creation/familleArticles/$id/view'
import { Route as AppCreationFamilleArticlesIdEditRouteImport } from './routes/_app/creation/familleArticles/$id/edit'
import { Route as AppCreationDossierTechniquesIdViewRouteImport } from './routes/_app/creation/dossier-techniques/$id/view'
import { Route as AppCreationDossierTechniquesIdEditRouteImport } from './routes/_app/creation/dossier-techniques/$id/edit'
import { Route as AppCreationAteliersIdViewRouteImport } from './routes/_app/creation/ateliers/$id/view'
import { Route as AppCreationAteliersIdEditRouteImport } from './routes/_app/creation/ateliers/$id/edit'
import { Route as AppCreationArticlesIdViewRouteImport } from './routes/_app/creation/articles/$id/view'
import { Route as AppCreationArticlesIdEditRouteImport } from './routes/_app/creation/articles/$id/edit'
import { Route as AppAchatsFournisseursIdViewRouteImport } from './routes/_app/achats/fournisseurs/$id/view'
import { Route as AppdashboardFraisIdViewRouteImport } from './routes/_app/(dashboard)/frais/$id/view'
import { Route as AppdashboardFraisIdEditRouteImport } from './routes/_app/(dashboard)/frais/$id/edit'
import { Route as AppRhCollaborateursIdViewRouteRouteImport } from './routes/_app/rh/collaborateurs/$id/view/route'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const PolitiqueConfidentialiteRoute =
  PolitiqueConfidentialiteRouteImport.update({
    id: '/politique-confidentialite',
    path: '/politique-confidentialite',
    getParentRoute: () => rootRouteImport,
  } as any)
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
  id: '/mentions-legales',
  path: '/mentions-legales',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSetupPasswordRoute = AuthSetupPasswordRouteImport.update({
  id: '/setup-password',
  path: '/setup-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppStockRouteRoute = AppStockRouteRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRhRouteRoute = AppRhRouteRouteImport.update({
  id: '/rh',
  path: '/rh',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppParametresRouteRoute = AppParametresRouteRouteImport.update({
  id: '/parametres',
  path: '/parametres',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCreationRouteRoute = AppCreationRouteRouteImport.update({
  id: '/creation',
  path: '/creation',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAchatsRouteRoute = AppAchatsRouteRouteImport.update({
  id: '/achats',
  path: '/achats',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppdashboardRouteRoute = AppdashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppRhIndexRoute = AppRhIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppCreationIndexRoute = AppCreationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppAchatsIndexRoute = AppAchatsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppdashboardIndexRoute = AppdashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AuthSignatureContratTokenRoute =
  AuthSignatureContratTokenRouteImport.update({
    id: '/signature-contrat/$token',
    path: '/signature-contrat/$token',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthPointageQrCodeRoute = AuthPointageQrCodeRouteImport.update({
  id: '/pointage/qr-code',
  path: '/pointage/qr-code',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPointageHashRoute = AuthPointageHashRouteImport.update({
  id: '/pointage/$hash',
  path: '/pointage/$hash',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppStockMouvementsRouteRoute = AppStockMouvementsRouteRouteImport.update({
  id: '/mouvements',
  path: '/mouvements',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppStockInventairesRouteRoute =
  AppStockInventairesRouteRouteImport.update({
    id: '/inventaires',
    path: '/inventaires',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppStockEmplacementsRouteRoute =
  AppStockEmplacementsRouteRouteImport.update({
    id: '/emplacements',
    path: '/emplacements',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppStockDepotsRouteRoute = AppStockDepotsRouteRouteImport.update({
  id: '/depots',
  path: '/depots',
  getParentRoute: () => AppStockRouteRoute,
} as any)
const AppStockConsultationRouteRoute =
  AppStockConsultationRouteRouteImport.update({
    id: '/consultation',
    path: '/consultation',
    getParentRoute: () => AppStockRouteRoute,
  } as any)
const AppRhPlanningRouteRoute = AppRhPlanningRouteRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhFeuillesDeTempsRouteRoute =
  AppRhFeuillesDeTempsRouteRouteImport.update({
    id: '/feuilles-de-temps',
    path: '/feuilles-de-temps',
    getParentRoute: () => AppRhRouteRoute,
  } as any)
const AppRhDocumentsRouteRoute = AppRhDocumentsRouteRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhContratsRouteRoute = AppRhContratsRouteRouteImport.update({
  id: '/contrats',
  path: '/contrats',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhCongesRouteRoute = AppRhCongesRouteRouteImport.update({
  id: '/conges',
  path: '/conges',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhCompetencesRouteRoute = AppRhCompetencesRouteRouteImport.update({
  id: '/competences',
  path: '/competences',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhCollaborateursRouteRoute =
  AppRhCollaborateursRouteRouteImport.update({
    id: '/collaborateurs',
    path: '/collaborateurs',
    getParentRoute: () => AppRhRouteRoute,
  } as any)
const AppCreationUniversCommerciauxRouteRoute =
  AppCreationUniversCommerciauxRouteRouteImport.update({
    id: '/univers-commerciaux',
    path: '/univers-commerciaux',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationPrestationsRouteRoute =
  AppCreationPrestationsRouteRouteImport.update({
    id: '/prestations',
    path: '/prestations',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationPostesRouteRoute = AppCreationPostesRouteRouteImport.update({
  id: '/postes',
  path: '/postes',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppCreationLdfRouteRoute = AppCreationLdfRouteRouteImport.update({
  id: '/ldf',
  path: '/ldf',
  getParentRoute: () => AppCreationRouteRoute,
} as any)
const AppCreationFamilleArticlesRouteRoute =
  AppCreationFamilleArticlesRouteRouteImport.update({
    id: '/familleArticles',
    path: '/familleArticles',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationDossierTechniquesRouteRoute =
  AppCreationDossierTechniquesRouteRouteImport.update({
    id: '/dossier-techniques',
    path: '/dossier-techniques',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationAteliersRouteRoute =
  AppCreationAteliersRouteRouteImport.update({
    id: '/ateliers',
    path: '/ateliers',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppCreationArticlesRouteRoute =
  AppCreationArticlesRouteRouteImport.update({
    id: '/articles',
    path: '/articles',
    getParentRoute: () => AppCreationRouteRoute,
  } as any)
const AppStockMouvementsIndexRoute = AppStockMouvementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStockMouvementsRouteRoute,
} as any)
const AppStockInventairesIndexRoute =
  AppStockInventairesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockEmplacementsIndexRoute =
  AppStockEmplacementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockConsultationIndexRoute =
  AppStockConsultationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppStockConsultationRouteRoute,
  } as any)
const AppRhPlanningIndexRoute = AppRhPlanningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhNotesDeFraisIndexRoute = AppRhNotesDeFraisIndexRouteImport.update({
  id: '/notes-de-frais/',
  path: '/notes-de-frais/',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhFeuillesDeTempsIndexRoute =
  AppRhFeuillesDeTempsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRhFeuillesDeTempsRouteRoute,
  } as any)
const AppRhDocumentsIndexRoute = AppRhDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhDocumentsRouteRoute,
} as any)
const AppRhContratsIndexRoute = AppRhContratsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhCongesIndexRoute = AppRhCongesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCompetencesIndexRoute = AppRhCompetencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRhCompetencesRouteRoute,
} as any)
const AppRhCollaborateursIndexRoute =
  AppRhCollaborateursIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIndexRoute =
  AppCreationUniversCommerciauxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationPrestationsIndexRoute =
  AppCreationPrestationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPostesIndexRoute = AppCreationPostesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationLdfIndexRoute = AppCreationLdfIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationFamilleArticlesIndexRoute =
  AppCreationFamilleArticlesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationDossierTechniquesIndexRoute =
  AppCreationDossierTechniquesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationAteliersIndexRoute =
  AppCreationAteliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationArticlesIndexRoute =
  AppCreationArticlesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppAchatsReceptionsIndexRoute =
  AppAchatsReceptionsIndexRouteImport.update({
    id: '/receptions/',
    path: '/receptions/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournituresIndexRoute =
  AppAchatsFournituresIndexRouteImport.update({
    id: '/fournitures/',
    path: '/fournitures/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFournisseursIndexRoute =
  AppAchatsFournisseursIndexRouteImport.update({
    id: '/fournisseurs/',
    path: '/fournisseurs/',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppAchatsFacturesIndexRoute = AppAchatsFacturesIndexRouteImport.update({
  id: '/factures/',
  path: '/factures/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppAchatsCommandesIndexRoute = AppAchatsCommandesIndexRouteImport.update({
  id: '/commandes/',
  path: '/commandes/',
  getParentRoute: () => AppAchatsRouteRoute,
} as any)
const AppdashboardProfileIndexRoute =
  AppdashboardProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardMesCongesIndexRoute =
  AppdashboardMesCongesIndexRouteImport.update({
    id: '/mes-conges/',
    path: '/mes-conges/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardFraisIndexRoute = AppdashboardFraisIndexRouteImport.update({
  id: '/frais/',
  path: '/frais/',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppStockMouvementsCreateRoute =
  AppStockMouvementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockInventairesCreateRoute =
  AppStockInventairesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockEmplacementsCreateRoute =
  AppStockEmplacementsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockDepotsCreateRoute = AppStockDepotsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppRhPlanningCreateRoute = AppRhPlanningCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhNotesDeFraisCreateRoute = AppRhNotesDeFraisCreateRouteImport.update({
  id: '/notes-de-frais/create',
  path: '/notes-de-frais/create',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhContratsCreateRoute = AppRhContratsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhCongesCreateRoute = AppRhCongesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCollaborateursCreateRoute =
  AppRhCollaborateursCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppCreationUniversCommerciauxCreateRoute =
  AppCreationUniversCommerciauxCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationPrestationsCreateRoute =
  AppCreationPrestationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPostesCreateRoute = AppCreationPostesCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationLdfCreateRoute = AppCreationLdfCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationFamilleArticlesCreateRoute =
  AppCreationFamilleArticlesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationDossierTechniquesCreateRoute =
  AppCreationDossierTechniquesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationAteliersCreateRoute =
  AppCreationAteliersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationArticlesCreateRoute =
  AppCreationArticlesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppdashboardFraisCreateRoute = AppdashboardFraisCreateRouteImport.update({
  id: '/frais/create',
  path: '/frais/create',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppRhCollaborateursIdIndexRoute =
  AppRhCollaborateursIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppdashboardPointageMeIndexRoute =
  AppdashboardPointageMeIndexRouteImport.update({
    id: '/pointage/me/',
    path: '/pointage/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardPlanningMeIndexRoute =
  AppdashboardPlanningMeIndexRouteImport.update({
    id: '/planning/me/',
    path: '/planning/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardFraisMeIndexRoute =
  AppdashboardFraisMeIndexRouteImport.update({
    id: '/frais/me/',
    path: '/frais/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardDocumentsMeIndexRoute =
  AppdashboardDocumentsMeIndexRouteImport.update({
    id: '/documents/me/',
    path: '/documents/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardContratsMeIndexRoute =
  AppdashboardContratsMeIndexRouteImport.update({
    id: '/contrats/me/',
    path: '/contrats/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppdashboardCongesMeIndexRoute =
  AppdashboardCongesMeIndexRouteImport.update({
    id: '/conges/me/',
    path: '/conges/me/',
    getParentRoute: () => AppdashboardRouteRoute,
  } as any)
const AppStockMouvementsIdViewRoute =
  AppStockMouvementsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockMouvementsIdEditRoute =
  AppStockMouvementsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockMouvementsRouteRoute,
  } as any)
const AppStockInventairesIdViewRoute =
  AppStockInventairesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockInventairesIdEditRoute =
  AppStockInventairesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockInventairesRouteRoute,
  } as any)
const AppStockEmplacementsIdViewRoute =
  AppStockEmplacementsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockEmplacementsIdEditRoute =
  AppStockEmplacementsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppStockEmplacementsRouteRoute,
  } as any)
const AppStockDepotsIdViewRoute = AppStockDepotsIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppStockDepotsIdEditRoute = AppStockDepotsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppStockDepotsRouteRoute,
} as any)
const AppRhPlanningIdViewRoute = AppRhPlanningIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhPlanningIdEditRoute = AppRhPlanningIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppRhPlanningRouteRoute,
} as any)
const AppRhNotesDeFraisIdViewRoute = AppRhNotesDeFraisIdViewRouteImport.update({
  id: '/notes-de-frais/$id/view',
  path: '/notes-de-frais/$id/view',
  getParentRoute: () => AppRhRouteRoute,
} as any)
const AppRhContratsIdViewRoute = AppRhContratsIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhContratsIdEditRoute = AppRhContratsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppRhContratsRouteRoute,
} as any)
const AppRhCongesDemandesNewRoute = AppRhCongesDemandesNewRouteImport.update({
  id: '/demandes/new',
  path: '/demandes/new',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCongesIdViewRoute = AppRhCongesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppRhCongesRouteRoute,
} as any)
const AppRhCollaborateursIdEditRoute =
  AppRhCollaborateursIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIdViewRoute =
  AppCreationUniversCommerciauxIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationUniversCommerciauxIdEditRoute =
  AppCreationUniversCommerciauxIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationUniversCommerciauxRouteRoute,
  } as any)
const AppCreationPrestationsIdViewRoute =
  AppCreationPrestationsIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPrestationsIdEditRoute =
  AppCreationPrestationsIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationPrestationsRouteRoute,
  } as any)
const AppCreationPostesIdViewRoute = AppCreationPostesIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationPostesIdEditRoute = AppCreationPostesIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppCreationPostesRouteRoute,
} as any)
const AppCreationLdfIdViewRoute = AppCreationLdfIdViewRouteImport.update({
  id: '/$id/view',
  path: '/$id/view',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationLdfIdEditRoute = AppCreationLdfIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppCreationLdfRouteRoute,
} as any)
const AppCreationFamilleArticlesIdViewRoute =
  AppCreationFamilleArticlesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationFamilleArticlesIdEditRoute =
  AppCreationFamilleArticlesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationFamilleArticlesRouteRoute,
  } as any)
const AppCreationDossierTechniquesIdViewRoute =
  AppCreationDossierTechniquesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationDossierTechniquesIdEditRoute =
  AppCreationDossierTechniquesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationDossierTechniquesRouteRoute,
  } as any)
const AppCreationAteliersIdViewRoute =
  AppCreationAteliersIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationAteliersIdEditRoute =
  AppCreationAteliersIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationAteliersRouteRoute,
  } as any)
const AppCreationArticlesIdViewRoute =
  AppCreationArticlesIdViewRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppCreationArticlesIdEditRoute =
  AppCreationArticlesIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AppCreationArticlesRouteRoute,
  } as any)
const AppAchatsFournisseursIdViewRoute =
  AppAchatsFournisseursIdViewRouteImport.update({
    id: '/fournisseurs/$id/view',
    path: '/fournisseurs/$id/view',
    getParentRoute: () => AppAchatsRouteRoute,
  } as any)
const AppdashboardFraisIdViewRoute = AppdashboardFraisIdViewRouteImport.update({
  id: '/frais/$id/view',
  path: '/frais/$id/view',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppdashboardFraisIdEditRoute = AppdashboardFraisIdEditRouteImport.update({
  id: '/frais/$id/edit',
  path: '/frais/$id/edit',
  getParentRoute: () => AppdashboardRouteRoute,
} as any)
const AppRhCollaborateursIdViewRouteRoute =
  AppRhCollaborateursIdViewRouteRouteImport.update({
    id: '/$id/view',
    path: '/$id/view',
    getParentRoute: () => AppRhCollaborateursRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppdashboardIndexRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/achats': typeof AppAchatsRouteRouteWithChildren
  '/creation': typeof AppCreationRouteRouteWithChildren
  '/parametres': typeof AppParametresRouteRoute
  '/rh': typeof AppRhRouteRouteWithChildren
  '/stock': typeof AppStockRouteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/setup-password': typeof AuthSetupPasswordRoute
  '/creation/articles': typeof AppCreationArticlesRouteRouteWithChildren
  '/creation/ateliers': typeof AppCreationAteliersRouteRouteWithChildren
  '/creation/dossier-techniques': typeof AppCreationDossierTechniquesRouteRouteWithChildren
  '/creation/familleArticles': typeof AppCreationFamilleArticlesRouteRouteWithChildren
  '/creation/ldf': typeof AppCreationLdfRouteRouteWithChildren
  '/creation/postes': typeof AppCreationPostesRouteRouteWithChildren
  '/creation/prestations': typeof AppCreationPrestationsRouteRouteWithChildren
  '/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  '/rh/collaborateurs': typeof AppRhCollaborateursRouteRouteWithChildren
  '/rh/competences': typeof AppRhCompetencesRouteRouteWithChildren
  '/rh/conges': typeof AppRhCongesRouteRouteWithChildren
  '/rh/contrats': typeof AppRhContratsRouteRouteWithChildren
  '/rh/documents': typeof AppRhDocumentsRouteRouteWithChildren
  '/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  '/rh/planning': typeof AppRhPlanningRouteRouteWithChildren
  '/stock/consultation': typeof AppStockConsultationRouteRouteWithChildren
  '/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/stock/emplacements': typeof AppStockEmplacementsRouteRouteWithChildren
  '/stock/inventaires': typeof AppStockInventairesRouteRouteWithChildren
  '/stock/mouvements': typeof AppStockMouvementsRouteRouteWithChildren
  '/pointage/$hash': typeof AuthPointageHashRoute
  '/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/achats/': typeof AppAchatsIndexRoute
  '/creation/': typeof AppCreationIndexRoute
  '/rh/': typeof AppRhIndexRoute
  '/stock/': typeof AppStockIndexRoute
  '/frais/create': typeof AppdashboardFraisCreateRoute
  '/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/rh/conges/create': typeof AppRhCongesCreateRoute
  '/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/frais/': typeof AppdashboardFraisIndexRoute
  '/mes-conges/': typeof AppdashboardMesCongesIndexRoute
  '/profile/': typeof AppdashboardProfileIndexRoute
  '/achats/commandes/': typeof AppAchatsCommandesIndexRoute
  '/achats/factures/': typeof AppAchatsFacturesIndexRoute
  '/achats/fournisseurs/': typeof AppAchatsFournisseursIndexRoute
  '/achats/fournitures/': typeof AppAchatsFournituresIndexRoute
  '/achats/receptions/': typeof AppAchatsReceptionsIndexRoute
  '/creation/articles/': typeof AppCreationArticlesIndexRoute
  '/creation/ateliers/': typeof AppCreationAteliersIndexRoute
  '/creation/dossier-techniques/': typeof AppCreationDossierTechniquesIndexRoute
  '/creation/familleArticles/': typeof AppCreationFamilleArticlesIndexRoute
  '/creation/ldf/': typeof AppCreationLdfIndexRoute
  '/creation/postes/': typeof AppCreationPostesIndexRoute
  '/creation/prestations/': typeof AppCreationPrestationsIndexRoute
  '/creation/univers-commerciaux/': typeof AppCreationUniversCommerciauxIndexRoute
  '/rh/collaborateurs/': typeof AppRhCollaborateursIndexRoute
  '/rh/competences/': typeof AppRhCompetencesIndexRoute
  '/rh/conges/': typeof AppRhCongesIndexRoute
  '/rh/contrats/': typeof AppRhContratsIndexRoute
  '/rh/documents/': typeof AppRhDocumentsIndexRoute
  '/rh/feuilles-de-temps/': typeof AppRhFeuillesDeTempsIndexRoute
  '/rh/notes-de-frais/': typeof AppRhNotesDeFraisIndexRoute
  '/rh/planning/': typeof AppRhPlanningIndexRoute
  '/stock/consultation/': typeof AppStockConsultationIndexRoute
  '/stock/emplacements/': typeof AppStockEmplacementsIndexRoute
  '/stock/inventaires/': typeof AppStockInventairesIndexRoute
  '/stock/mouvements/': typeof AppStockMouvementsIndexRoute
  '/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/conges/me/': typeof AppdashboardCongesMeIndexRoute
  '/contrats/me/': typeof AppdashboardContratsMeIndexRoute
  '/documents/me/': typeof AppdashboardDocumentsMeIndexRoute
  '/frais/me/': typeof AppdashboardFraisMeIndexRoute
  '/planning/me/': typeof AppdashboardPlanningMeIndexRoute
  '/pointage/me/': typeof AppdashboardPointageMeIndexRoute
  '/rh/collaborateurs/$id/': typeof AppRhCollaborateursIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppdashboardIndexRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/parametres': typeof AppParametresRouteRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/setup-password': typeof AuthSetupPasswordRoute
  '/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/pointage/$hash': typeof AuthPointageHashRoute
  '/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/achats': typeof AppAchatsIndexRoute
  '/creation': typeof AppCreationIndexRoute
  '/rh': typeof AppRhIndexRoute
  '/stock': typeof AppStockIndexRoute
  '/frais/create': typeof AppdashboardFraisCreateRoute
  '/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/rh/conges/create': typeof AppRhCongesCreateRoute
  '/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/frais': typeof AppdashboardFraisIndexRoute
  '/mes-conges': typeof AppdashboardMesCongesIndexRoute
  '/profile': typeof AppdashboardProfileIndexRoute
  '/achats/commandes': typeof AppAchatsCommandesIndexRoute
  '/achats/factures': typeof AppAchatsFacturesIndexRoute
  '/achats/fournisseurs': typeof AppAchatsFournisseursIndexRoute
  '/achats/fournitures': typeof AppAchatsFournituresIndexRoute
  '/achats/receptions': typeof AppAchatsReceptionsIndexRoute
  '/creation/articles': typeof AppCreationArticlesIndexRoute
  '/creation/ateliers': typeof AppCreationAteliersIndexRoute
  '/creation/dossier-techniques': typeof AppCreationDossierTechniquesIndexRoute
  '/creation/familleArticles': typeof AppCreationFamilleArticlesIndexRoute
  '/creation/ldf': typeof AppCreationLdfIndexRoute
  '/creation/postes': typeof AppCreationPostesIndexRoute
  '/creation/prestations': typeof AppCreationPrestationsIndexRoute
  '/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxIndexRoute
  '/rh/collaborateurs': typeof AppRhCollaborateursIndexRoute
  '/rh/competences': typeof AppRhCompetencesIndexRoute
  '/rh/conges': typeof AppRhCongesIndexRoute
  '/rh/contrats': typeof AppRhContratsIndexRoute
  '/rh/documents': typeof AppRhDocumentsIndexRoute
  '/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsIndexRoute
  '/rh/notes-de-frais': typeof AppRhNotesDeFraisIndexRoute
  '/rh/planning': typeof AppRhPlanningIndexRoute
  '/stock/consultation': typeof AppStockConsultationIndexRoute
  '/stock/emplacements': typeof AppStockEmplacementsIndexRoute
  '/stock/inventaires': typeof AppStockInventairesIndexRoute
  '/stock/mouvements': typeof AppStockMouvementsIndexRoute
  '/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/conges/me': typeof AppdashboardCongesMeIndexRoute
  '/contrats/me': typeof AppdashboardContratsMeIndexRoute
  '/documents/me': typeof AppdashboardDocumentsMeIndexRoute
  '/frais/me': typeof AppdashboardFraisMeIndexRoute
  '/planning/me': typeof AppdashboardPlanningMeIndexRoute
  '/pointage/me': typeof AppdashboardPointageMeIndexRoute
  '/rh/collaborateurs/$id': typeof AppRhCollaborateursIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/mentions-legales': typeof MentionsLegalesRoute
  '/politique-confidentialite': typeof PolitiqueConfidentialiteRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_app/(dashboard)': typeof AppdashboardRouteRouteWithChildren
  '/_app/achats': typeof AppAchatsRouteRouteWithChildren
  '/_app/creation': typeof AppCreationRouteRouteWithChildren
  '/_app/parametres': typeof AppParametresRouteRoute
  '/_app/rh': typeof AppRhRouteRouteWithChildren
  '/_app/stock': typeof AppStockRouteRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/setup-password': typeof AuthSetupPasswordRoute
  '/_app/creation/articles': typeof AppCreationArticlesRouteRouteWithChildren
  '/_app/creation/ateliers': typeof AppCreationAteliersRouteRouteWithChildren
  '/_app/creation/dossier-techniques': typeof AppCreationDossierTechniquesRouteRouteWithChildren
  '/_app/creation/familleArticles': typeof AppCreationFamilleArticlesRouteRouteWithChildren
  '/_app/creation/ldf': typeof AppCreationLdfRouteRouteWithChildren
  '/_app/creation/postes': typeof AppCreationPostesRouteRouteWithChildren
  '/_app/creation/prestations': typeof AppCreationPrestationsRouteRouteWithChildren
  '/_app/creation/univers-commerciaux': typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  '/_app/rh/collaborateurs': typeof AppRhCollaborateursRouteRouteWithChildren
  '/_app/rh/competences': typeof AppRhCompetencesRouteRouteWithChildren
  '/_app/rh/conges': typeof AppRhCongesRouteRouteWithChildren
  '/_app/rh/contrats': typeof AppRhContratsRouteRouteWithChildren
  '/_app/rh/documents': typeof AppRhDocumentsRouteRouteWithChildren
  '/_app/rh/feuilles-de-temps': typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  '/_app/rh/planning': typeof AppRhPlanningRouteRouteWithChildren
  '/_app/stock/consultation': typeof AppStockConsultationRouteRouteWithChildren
  '/_app/stock/depots': typeof AppStockDepotsRouteRouteWithChildren
  '/_app/stock/emplacements': typeof AppStockEmplacementsRouteRouteWithChildren
  '/_app/stock/inventaires': typeof AppStockInventairesRouteRouteWithChildren
  '/_app/stock/mouvements': typeof AppStockMouvementsRouteRouteWithChildren
  '/_auth/pointage/$hash': typeof AuthPointageHashRoute
  '/_auth/pointage/qr-code': typeof AuthPointageQrCodeRoute
  '/_auth/signature-contrat/$token': typeof AuthSignatureContratTokenRoute
  '/_app/(dashboard)/': typeof AppdashboardIndexRoute
  '/_app/achats/': typeof AppAchatsIndexRoute
  '/_app/creation/': typeof AppCreationIndexRoute
  '/_app/rh/': typeof AppRhIndexRoute
  '/_app/stock/': typeof AppStockIndexRoute
  '/_app/(dashboard)/frais/create': typeof AppdashboardFraisCreateRoute
  '/_app/creation/articles/create': typeof AppCreationArticlesCreateRoute
  '/_app/creation/ateliers/create': typeof AppCreationAteliersCreateRoute
  '/_app/creation/dossier-techniques/create': typeof AppCreationDossierTechniquesCreateRoute
  '/_app/creation/familleArticles/create': typeof AppCreationFamilleArticlesCreateRoute
  '/_app/creation/ldf/create': typeof AppCreationLdfCreateRoute
  '/_app/creation/postes/create': typeof AppCreationPostesCreateRoute
  '/_app/creation/prestations/create': typeof AppCreationPrestationsCreateRoute
  '/_app/creation/univers-commerciaux/create': typeof AppCreationUniversCommerciauxCreateRoute
  '/_app/rh/collaborateurs/create': typeof AppRhCollaborateursCreateRoute
  '/_app/rh/conges/create': typeof AppRhCongesCreateRoute
  '/_app/rh/contrats/create': typeof AppRhContratsCreateRoute
  '/_app/rh/notes-de-frais/create': typeof AppRhNotesDeFraisCreateRoute
  '/_app/rh/planning/create': typeof AppRhPlanningCreateRoute
  '/_app/stock/depots/create': typeof AppStockDepotsCreateRoute
  '/_app/stock/emplacements/create': typeof AppStockEmplacementsCreateRoute
  '/_app/stock/inventaires/create': typeof AppStockInventairesCreateRoute
  '/_app/stock/mouvements/create': typeof AppStockMouvementsCreateRoute
  '/_app/(dashboard)/frais/': typeof AppdashboardFraisIndexRoute
  '/_app/(dashboard)/mes-conges/': typeof AppdashboardMesCongesIndexRoute
  '/_app/(dashboard)/profile/': typeof AppdashboardProfileIndexRoute
  '/_app/achats/commandes/': typeof AppAchatsCommandesIndexRoute
  '/_app/achats/factures/': typeof AppAchatsFacturesIndexRoute
  '/_app/achats/fournisseurs/': typeof AppAchatsFournisseursIndexRoute
  '/_app/achats/fournitures/': typeof AppAchatsFournituresIndexRoute
  '/_app/achats/receptions/': typeof AppAchatsReceptionsIndexRoute
  '/_app/creation/articles/': typeof AppCreationArticlesIndexRoute
  '/_app/creation/ateliers/': typeof AppCreationAteliersIndexRoute
  '/_app/creation/dossier-techniques/': typeof AppCreationDossierTechniquesIndexRoute
  '/_app/creation/familleArticles/': typeof AppCreationFamilleArticlesIndexRoute
  '/_app/creation/ldf/': typeof AppCreationLdfIndexRoute
  '/_app/creation/postes/': typeof AppCreationPostesIndexRoute
  '/_app/creation/prestations/': typeof AppCreationPrestationsIndexRoute
  '/_app/creation/univers-commerciaux/': typeof AppCreationUniversCommerciauxIndexRoute
  '/_app/rh/collaborateurs/': typeof AppRhCollaborateursIndexRoute
  '/_app/rh/competences/': typeof AppRhCompetencesIndexRoute
  '/_app/rh/conges/': typeof AppRhCongesIndexRoute
  '/_app/rh/contrats/': typeof AppRhContratsIndexRoute
  '/_app/rh/documents/': typeof AppRhDocumentsIndexRoute
  '/_app/rh/feuilles-de-temps/': typeof AppRhFeuillesDeTempsIndexRoute
  '/_app/rh/notes-de-frais/': typeof AppRhNotesDeFraisIndexRoute
  '/_app/rh/planning/': typeof AppRhPlanningIndexRoute
  '/_app/stock/consultation/': typeof AppStockConsultationIndexRoute
  '/_app/stock/emplacements/': typeof AppStockEmplacementsIndexRoute
  '/_app/stock/inventaires/': typeof AppStockInventairesIndexRoute
  '/_app/stock/mouvements/': typeof AppStockMouvementsIndexRoute
  '/_app/rh/collaborateurs/$id/view': typeof AppRhCollaborateursIdViewRouteRoute
  '/_app/(dashboard)/frais/$id/edit': typeof AppdashboardFraisIdEditRoute
  '/_app/(dashboard)/frais/$id/view': typeof AppdashboardFraisIdViewRoute
  '/_app/achats/fournisseurs/$id/view': typeof AppAchatsFournisseursIdViewRoute
  '/_app/creation/articles/$id/edit': typeof AppCreationArticlesIdEditRoute
  '/_app/creation/articles/$id/view': typeof AppCreationArticlesIdViewRoute
  '/_app/creation/ateliers/$id/edit': typeof AppCreationAteliersIdEditRoute
  '/_app/creation/ateliers/$id/view': typeof AppCreationAteliersIdViewRoute
  '/_app/creation/dossier-techniques/$id/edit': typeof AppCreationDossierTechniquesIdEditRoute
  '/_app/creation/dossier-techniques/$id/view': typeof AppCreationDossierTechniquesIdViewRoute
  '/_app/creation/familleArticles/$id/edit': typeof AppCreationFamilleArticlesIdEditRoute
  '/_app/creation/familleArticles/$id/view': typeof AppCreationFamilleArticlesIdViewRoute
  '/_app/creation/ldf/$id/edit': typeof AppCreationLdfIdEditRoute
  '/_app/creation/ldf/$id/view': typeof AppCreationLdfIdViewRoute
  '/_app/creation/postes/$id/edit': typeof AppCreationPostesIdEditRoute
  '/_app/creation/postes/$id/view': typeof AppCreationPostesIdViewRoute
  '/_app/creation/prestations/$id/edit': typeof AppCreationPrestationsIdEditRoute
  '/_app/creation/prestations/$id/view': typeof AppCreationPrestationsIdViewRoute
  '/_app/creation/univers-commerciaux/$id/edit': typeof AppCreationUniversCommerciauxIdEditRoute
  '/_app/creation/univers-commerciaux/$id/view': typeof AppCreationUniversCommerciauxIdViewRoute
  '/_app/rh/collaborateurs/$id/edit': typeof AppRhCollaborateursIdEditRoute
  '/_app/rh/conges/$id/view': typeof AppRhCongesIdViewRoute
  '/_app/rh/conges/demandes/new': typeof AppRhCongesDemandesNewRoute
  '/_app/rh/contrats/$id/edit': typeof AppRhContratsIdEditRoute
  '/_app/rh/contrats/$id/view': typeof AppRhContratsIdViewRoute
  '/_app/rh/notes-de-frais/$id/view': typeof AppRhNotesDeFraisIdViewRoute
  '/_app/rh/planning/$id/edit': typeof AppRhPlanningIdEditRoute
  '/_app/rh/planning/$id/view': typeof AppRhPlanningIdViewRoute
  '/_app/stock/depots/$id/edit': typeof AppStockDepotsIdEditRoute
  '/_app/stock/depots/$id/view': typeof AppStockDepotsIdViewRoute
  '/_app/stock/emplacements/$id/edit': typeof AppStockEmplacementsIdEditRoute
  '/_app/stock/emplacements/$id/view': typeof AppStockEmplacementsIdViewRoute
  '/_app/stock/inventaires/$id/edit': typeof AppStockInventairesIdEditRoute
  '/_app/stock/inventaires/$id/view': typeof AppStockInventairesIdViewRoute
  '/_app/stock/mouvements/$id/edit': typeof AppStockMouvementsIdEditRoute
  '/_app/stock/mouvements/$id/view': typeof AppStockMouvementsIdViewRoute
  '/_app/(dashboard)/conges/me/': typeof AppdashboardCongesMeIndexRoute
  '/_app/(dashboard)/contrats/me/': typeof AppdashboardContratsMeIndexRoute
  '/_app/(dashboard)/documents/me/': typeof AppdashboardDocumentsMeIndexRoute
  '/_app/(dashboard)/frais/me/': typeof AppdashboardFraisMeIndexRoute
  '/_app/(dashboard)/planning/me/': typeof AppdashboardPlanningMeIndexRoute
  '/_app/(dashboard)/pointage/me/': typeof AppdashboardPointageMeIndexRoute
  '/_app/rh/collaborateurs/$id/': typeof AppRhCollaborateursIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/achats'
    | '/creation'
    | '/parametres'
    | '/rh'
    | '/stock'
    | '/forgot-password'
    | '/login'
    | '/setup-password'
    | '/creation/articles'
    | '/creation/ateliers'
    | '/creation/dossier-techniques'
    | '/creation/familleArticles'
    | '/creation/ldf'
    | '/creation/postes'
    | '/creation/prestations'
    | '/creation/univers-commerciaux'
    | '/rh/collaborateurs'
    | '/rh/competences'
    | '/rh/conges'
    | '/rh/contrats'
    | '/rh/documents'
    | '/rh/feuilles-de-temps'
    | '/rh/planning'
    | '/stock/consultation'
    | '/stock/depots'
    | '/stock/emplacements'
    | '/stock/inventaires'
    | '/stock/mouvements'
    | '/pointage/$hash'
    | '/pointage/qr-code'
    | '/signature-contrat/$token'
    | '/achats/'
    | '/creation/'
    | '/rh/'
    | '/stock/'
    | '/frais/create'
    | '/creation/articles/create'
    | '/creation/ateliers/create'
    | '/creation/dossier-techniques/create'
    | '/creation/familleArticles/create'
    | '/creation/ldf/create'
    | '/creation/postes/create'
    | '/creation/prestations/create'
    | '/creation/univers-commerciaux/create'
    | '/rh/collaborateurs/create'
    | '/rh/conges/create'
    | '/rh/contrats/create'
    | '/rh/notes-de-frais/create'
    | '/rh/planning/create'
    | '/stock/depots/create'
    | '/stock/emplacements/create'
    | '/stock/inventaires/create'
    | '/stock/mouvements/create'
    | '/frais/'
    | '/mes-conges/'
    | '/profile/'
    | '/achats/commandes/'
    | '/achats/factures/'
    | '/achats/fournisseurs/'
    | '/achats/fournitures/'
    | '/achats/receptions/'
    | '/creation/articles/'
    | '/creation/ateliers/'
    | '/creation/dossier-techniques/'
    | '/creation/familleArticles/'
    | '/creation/ldf/'
    | '/creation/postes/'
    | '/creation/prestations/'
    | '/creation/univers-commerciaux/'
    | '/rh/collaborateurs/'
    | '/rh/competences/'
    | '/rh/conges/'
    | '/rh/contrats/'
    | '/rh/documents/'
    | '/rh/feuilles-de-temps/'
    | '/rh/notes-de-frais/'
    | '/rh/planning/'
    | '/stock/consultation/'
    | '/stock/emplacements/'
    | '/stock/inventaires/'
    | '/stock/mouvements/'
    | '/rh/collaborateurs/$id/view'
    | '/frais/$id/edit'
    | '/frais/$id/view'
    | '/achats/fournisseurs/$id/view'
    | '/creation/articles/$id/edit'
    | '/creation/articles/$id/view'
    | '/creation/ateliers/$id/edit'
    | '/creation/ateliers/$id/view'
    | '/creation/dossier-techniques/$id/edit'
    | '/creation/dossier-techniques/$id/view'
    | '/creation/familleArticles/$id/edit'
    | '/creation/familleArticles/$id/view'
    | '/creation/ldf/$id/edit'
    | '/creation/ldf/$id/view'
    | '/creation/postes/$id/edit'
    | '/creation/postes/$id/view'
    | '/creation/prestations/$id/edit'
    | '/creation/prestations/$id/view'
    | '/creation/univers-commerciaux/$id/edit'
    | '/creation/univers-commerciaux/$id/view'
    | '/rh/collaborateurs/$id/edit'
    | '/rh/conges/$id/view'
    | '/rh/conges/demandes/new'
    | '/rh/contrats/$id/edit'
    | '/rh/contrats/$id/view'
    | '/rh/notes-de-frais/$id/view'
    | '/rh/planning/$id/edit'
    | '/rh/planning/$id/view'
    | '/stock/depots/$id/edit'
    | '/stock/depots/$id/view'
    | '/stock/emplacements/$id/edit'
    | '/stock/emplacements/$id/view'
    | '/stock/inventaires/$id/edit'
    | '/stock/inventaires/$id/view'
    | '/stock/mouvements/$id/edit'
    | '/stock/mouvements/$id/view'
    | '/conges/me/'
    | '/contrats/me/'
    | '/documents/me/'
    | '/frais/me/'
    | '/planning/me/'
    | '/pointage/me/'
    | '/rh/collaborateurs/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/parametres'
    | '/forgot-password'
    | '/login'
    | '/setup-password'
    | '/stock/depots'
    | '/pointage/$hash'
    | '/pointage/qr-code'
    | '/signature-contrat/$token'
    | '/achats'
    | '/creation'
    | '/rh'
    | '/stock'
    | '/frais/create'
    | '/creation/articles/create'
    | '/creation/ateliers/create'
    | '/creation/dossier-techniques/create'
    | '/creation/familleArticles/create'
    | '/creation/ldf/create'
    | '/creation/postes/create'
    | '/creation/prestations/create'
    | '/creation/univers-commerciaux/create'
    | '/rh/collaborateurs/create'
    | '/rh/conges/create'
    | '/rh/contrats/create'
    | '/rh/notes-de-frais/create'
    | '/rh/planning/create'
    | '/stock/depots/create'
    | '/stock/emplacements/create'
    | '/stock/inventaires/create'
    | '/stock/mouvements/create'
    | '/frais'
    | '/mes-conges'
    | '/profile'
    | '/achats/commandes'
    | '/achats/factures'
    | '/achats/fournisseurs'
    | '/achats/fournitures'
    | '/achats/receptions'
    | '/creation/articles'
    | '/creation/ateliers'
    | '/creation/dossier-techniques'
    | '/creation/familleArticles'
    | '/creation/ldf'
    | '/creation/postes'
    | '/creation/prestations'
    | '/creation/univers-commerciaux'
    | '/rh/collaborateurs'
    | '/rh/competences'
    | '/rh/conges'
    | '/rh/contrats'
    | '/rh/documents'
    | '/rh/feuilles-de-temps'
    | '/rh/notes-de-frais'
    | '/rh/planning'
    | '/stock/consultation'
    | '/stock/emplacements'
    | '/stock/inventaires'
    | '/stock/mouvements'
    | '/rh/collaborateurs/$id/view'
    | '/frais/$id/edit'
    | '/frais/$id/view'
    | '/achats/fournisseurs/$id/view'
    | '/creation/articles/$id/edit'
    | '/creation/articles/$id/view'
    | '/creation/ateliers/$id/edit'
    | '/creation/ateliers/$id/view'
    | '/creation/dossier-techniques/$id/edit'
    | '/creation/dossier-techniques/$id/view'
    | '/creation/familleArticles/$id/edit'
    | '/creation/familleArticles/$id/view'
    | '/creation/ldf/$id/edit'
    | '/creation/ldf/$id/view'
    | '/creation/postes/$id/edit'
    | '/creation/postes/$id/view'
    | '/creation/prestations/$id/edit'
    | '/creation/prestations/$id/view'
    | '/creation/univers-commerciaux/$id/edit'
    | '/creation/univers-commerciaux/$id/view'
    | '/rh/collaborateurs/$id/edit'
    | '/rh/conges/$id/view'
    | '/rh/conges/demandes/new'
    | '/rh/contrats/$id/edit'
    | '/rh/contrats/$id/view'
    | '/rh/notes-de-frais/$id/view'
    | '/rh/planning/$id/edit'
    | '/rh/planning/$id/view'
    | '/stock/depots/$id/edit'
    | '/stock/depots/$id/view'
    | '/stock/emplacements/$id/edit'
    | '/stock/emplacements/$id/view'
    | '/stock/inventaires/$id/edit'
    | '/stock/inventaires/$id/view'
    | '/stock/mouvements/$id/edit'
    | '/stock/mouvements/$id/view'
    | '/conges/me'
    | '/contrats/me'
    | '/documents/me'
    | '/frais/me'
    | '/planning/me'
    | '/pointage/me'
    | '/rh/collaborateurs/$id'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/mentions-legales'
    | '/politique-confidentialite'
    | '/unauthorized'
    | '/_app/(dashboard)'
    | '/_app/achats'
    | '/_app/creation'
    | '/_app/parametres'
    | '/_app/rh'
    | '/_app/stock'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/setup-password'
    | '/_app/creation/articles'
    | '/_app/creation/ateliers'
    | '/_app/creation/dossier-techniques'
    | '/_app/creation/familleArticles'
    | '/_app/creation/ldf'
    | '/_app/creation/postes'
    | '/_app/creation/prestations'
    | '/_app/creation/univers-commerciaux'
    | '/_app/rh/collaborateurs'
    | '/_app/rh/competences'
    | '/_app/rh/conges'
    | '/_app/rh/contrats'
    | '/_app/rh/documents'
    | '/_app/rh/feuilles-de-temps'
    | '/_app/rh/planning'
    | '/_app/stock/consultation'
    | '/_app/stock/depots'
    | '/_app/stock/emplacements'
    | '/_app/stock/inventaires'
    | '/_app/stock/mouvements'
    | '/_auth/pointage/$hash'
    | '/_auth/pointage/qr-code'
    | '/_auth/signature-contrat/$token'
    | '/_app/(dashboard)/'
    | '/_app/achats/'
    | '/_app/creation/'
    | '/_app/rh/'
    | '/_app/stock/'
    | '/_app/(dashboard)/frais/create'
    | '/_app/creation/articles/create'
    | '/_app/creation/ateliers/create'
    | '/_app/creation/dossier-techniques/create'
    | '/_app/creation/familleArticles/create'
    | '/_app/creation/ldf/create'
    | '/_app/creation/postes/create'
    | '/_app/creation/prestations/create'
    | '/_app/creation/univers-commerciaux/create'
    | '/_app/rh/collaborateurs/create'
    | '/_app/rh/conges/create'
    | '/_app/rh/contrats/create'
    | '/_app/rh/notes-de-frais/create'
    | '/_app/rh/planning/create'
    | '/_app/stock/depots/create'
    | '/_app/stock/emplacements/create'
    | '/_app/stock/inventaires/create'
    | '/_app/stock/mouvements/create'
    | '/_app/(dashboard)/frais/'
    | '/_app/(dashboard)/mes-conges/'
    | '/_app/(dashboard)/profile/'
    | '/_app/achats/commandes/'
    | '/_app/achats/factures/'
    | '/_app/achats/fournisseurs/'
    | '/_app/achats/fournitures/'
    | '/_app/achats/receptions/'
    | '/_app/creation/articles/'
    | '/_app/creation/ateliers/'
    | '/_app/creation/dossier-techniques/'
    | '/_app/creation/familleArticles/'
    | '/_app/creation/ldf/'
    | '/_app/creation/postes/'
    | '/_app/creation/prestations/'
    | '/_app/creation/univers-commerciaux/'
    | '/_app/rh/collaborateurs/'
    | '/_app/rh/competences/'
    | '/_app/rh/conges/'
    | '/_app/rh/contrats/'
    | '/_app/rh/documents/'
    | '/_app/rh/feuilles-de-temps/'
    | '/_app/rh/notes-de-frais/'
    | '/_app/rh/planning/'
    | '/_app/stock/consultation/'
    | '/_app/stock/emplacements/'
    | '/_app/stock/inventaires/'
    | '/_app/stock/mouvements/'
    | '/_app/rh/collaborateurs/$id/view'
    | '/_app/(dashboard)/frais/$id/edit'
    | '/_app/(dashboard)/frais/$id/view'
    | '/_app/achats/fournisseurs/$id/view'
    | '/_app/creation/articles/$id/edit'
    | '/_app/creation/articles/$id/view'
    | '/_app/creation/ateliers/$id/edit'
    | '/_app/creation/ateliers/$id/view'
    | '/_app/creation/dossier-techniques/$id/edit'
    | '/_app/creation/dossier-techniques/$id/view'
    | '/_app/creation/familleArticles/$id/edit'
    | '/_app/creation/familleArticles/$id/view'
    | '/_app/creation/ldf/$id/edit'
    | '/_app/creation/ldf/$id/view'
    | '/_app/creation/postes/$id/edit'
    | '/_app/creation/postes/$id/view'
    | '/_app/creation/prestations/$id/edit'
    | '/_app/creation/prestations/$id/view'
    | '/_app/creation/univers-commerciaux/$id/edit'
    | '/_app/creation/univers-commerciaux/$id/view'
    | '/_app/rh/collaborateurs/$id/edit'
    | '/_app/rh/conges/$id/view'
    | '/_app/rh/conges/demandes/new'
    | '/_app/rh/contrats/$id/edit'
    | '/_app/rh/contrats/$id/view'
    | '/_app/rh/notes-de-frais/$id/view'
    | '/_app/rh/planning/$id/edit'
    | '/_app/rh/planning/$id/view'
    | '/_app/stock/depots/$id/edit'
    | '/_app/stock/depots/$id/view'
    | '/_app/stock/emplacements/$id/edit'
    | '/_app/stock/emplacements/$id/view'
    | '/_app/stock/inventaires/$id/edit'
    | '/_app/stock/inventaires/$id/view'
    | '/_app/stock/mouvements/$id/edit'
    | '/_app/stock/mouvements/$id/view'
    | '/_app/(dashboard)/conges/me/'
    | '/_app/(dashboard)/contrats/me/'
    | '/_app/(dashboard)/documents/me/'
    | '/_app/(dashboard)/frais/me/'
    | '/_app/(dashboard)/planning/me/'
    | '/_app/(dashboard)/pointage/me/'
    | '/_app/rh/collaborateurs/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  MentionsLegalesRoute: typeof MentionsLegalesRoute
  PolitiqueConfidentialiteRoute: typeof PolitiqueConfidentialiteRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politique-confidentialite': {
      id: '/politique-confidentialite'
      path: '/politique-confidentialite'
      fullPath: '/politique-confidentialite'
      preLoaderRoute: typeof PolitiqueConfidentialiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mentions-legales': {
      id: '/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof MentionsLegalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/setup-password': {
      id: '/_auth/setup-password'
      path: '/setup-password'
      fullPath: '/setup-password'
      preLoaderRoute: typeof AuthSetupPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/stock': {
      id: '/_app/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof AppStockRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rh': {
      id: '/_app/rh'
      path: '/rh'
      fullPath: '/rh'
      preLoaderRoute: typeof AppRhRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/parametres': {
      id: '/_app/parametres'
      path: '/parametres'
      fullPath: '/parametres'
      preLoaderRoute: typeof AppParametresRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/creation': {
      id: '/_app/creation'
      path: '/creation'
      fullPath: '/creation'
      preLoaderRoute: typeof AppCreationRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/achats': {
      id: '/_app/achats'
      path: '/achats'
      fullPath: '/achats'
      preLoaderRoute: typeof AppAchatsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(dashboard)': {
      id: '/_app/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppdashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/stock/': {
      id: '/_app/stock/'
      path: '/'
      fullPath: '/stock/'
      preLoaderRoute: typeof AppStockIndexRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/rh/': {
      id: '/_app/rh/'
      path: '/'
      fullPath: '/rh/'
      preLoaderRoute: typeof AppRhIndexRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/creation/': {
      id: '/_app/creation/'
      path: '/'
      fullPath: '/creation/'
      preLoaderRoute: typeof AppCreationIndexRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/achats/': {
      id: '/_app/achats/'
      path: '/'
      fullPath: '/achats/'
      preLoaderRoute: typeof AppAchatsIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/(dashboard)/': {
      id: '/_app/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppdashboardIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_auth/signature-contrat/$token': {
      id: '/_auth/signature-contrat/$token'
      path: '/signature-contrat/$token'
      fullPath: '/signature-contrat/$token'
      preLoaderRoute: typeof AuthSignatureContratTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/pointage/qr-code': {
      id: '/_auth/pointage/qr-code'
      path: '/pointage/qr-code'
      fullPath: '/pointage/qr-code'
      preLoaderRoute: typeof AuthPointageQrCodeRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/pointage/$hash': {
      id: '/_auth/pointage/$hash'
      path: '/pointage/$hash'
      fullPath: '/pointage/$hash'
      preLoaderRoute: typeof AuthPointageHashRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/stock/mouvements': {
      id: '/_app/stock/mouvements'
      path: '/mouvements'
      fullPath: '/stock/mouvements'
      preLoaderRoute: typeof AppStockMouvementsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/inventaires': {
      id: '/_app/stock/inventaires'
      path: '/inventaires'
      fullPath: '/stock/inventaires'
      preLoaderRoute: typeof AppStockInventairesRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/emplacements': {
      id: '/_app/stock/emplacements'
      path: '/emplacements'
      fullPath: '/stock/emplacements'
      preLoaderRoute: typeof AppStockEmplacementsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/depots': {
      id: '/_app/stock/depots'
      path: '/depots'
      fullPath: '/stock/depots'
      preLoaderRoute: typeof AppStockDepotsRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/stock/consultation': {
      id: '/_app/stock/consultation'
      path: '/consultation'
      fullPath: '/stock/consultation'
      preLoaderRoute: typeof AppStockConsultationRouteRouteImport
      parentRoute: typeof AppStockRouteRoute
    }
    '/_app/rh/planning': {
      id: '/_app/rh/planning'
      path: '/planning'
      fullPath: '/rh/planning'
      preLoaderRoute: typeof AppRhPlanningRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/feuilles-de-temps': {
      id: '/_app/rh/feuilles-de-temps'
      path: '/feuilles-de-temps'
      fullPath: '/rh/feuilles-de-temps'
      preLoaderRoute: typeof AppRhFeuillesDeTempsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/documents': {
      id: '/_app/rh/documents'
      path: '/documents'
      fullPath: '/rh/documents'
      preLoaderRoute: typeof AppRhDocumentsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/contrats': {
      id: '/_app/rh/contrats'
      path: '/contrats'
      fullPath: '/rh/contrats'
      preLoaderRoute: typeof AppRhContratsRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/conges': {
      id: '/_app/rh/conges'
      path: '/conges'
      fullPath: '/rh/conges'
      preLoaderRoute: typeof AppRhCongesRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/competences': {
      id: '/_app/rh/competences'
      path: '/competences'
      fullPath: '/rh/competences'
      preLoaderRoute: typeof AppRhCompetencesRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/collaborateurs': {
      id: '/_app/rh/collaborateurs'
      path: '/collaborateurs'
      fullPath: '/rh/collaborateurs'
      preLoaderRoute: typeof AppRhCollaborateursRouteRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/creation/univers-commerciaux': {
      id: '/_app/creation/univers-commerciaux'
      path: '/univers-commerciaux'
      fullPath: '/creation/univers-commerciaux'
      preLoaderRoute: typeof AppCreationUniversCommerciauxRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/prestations': {
      id: '/_app/creation/prestations'
      path: '/prestations'
      fullPath: '/creation/prestations'
      preLoaderRoute: typeof AppCreationPrestationsRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/postes': {
      id: '/_app/creation/postes'
      path: '/postes'
      fullPath: '/creation/postes'
      preLoaderRoute: typeof AppCreationPostesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/ldf': {
      id: '/_app/creation/ldf'
      path: '/ldf'
      fullPath: '/creation/ldf'
      preLoaderRoute: typeof AppCreationLdfRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/familleArticles': {
      id: '/_app/creation/familleArticles'
      path: '/familleArticles'
      fullPath: '/creation/familleArticles'
      preLoaderRoute: typeof AppCreationFamilleArticlesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/dossier-techniques': {
      id: '/_app/creation/dossier-techniques'
      path: '/dossier-techniques'
      fullPath: '/creation/dossier-techniques'
      preLoaderRoute: typeof AppCreationDossierTechniquesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/ateliers': {
      id: '/_app/creation/ateliers'
      path: '/ateliers'
      fullPath: '/creation/ateliers'
      preLoaderRoute: typeof AppCreationAteliersRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/creation/articles': {
      id: '/_app/creation/articles'
      path: '/articles'
      fullPath: '/creation/articles'
      preLoaderRoute: typeof AppCreationArticlesRouteRouteImport
      parentRoute: typeof AppCreationRouteRoute
    }
    '/_app/stock/mouvements/': {
      id: '/_app/stock/mouvements/'
      path: '/'
      fullPath: '/stock/mouvements/'
      preLoaderRoute: typeof AppStockMouvementsIndexRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/inventaires/': {
      id: '/_app/stock/inventaires/'
      path: '/'
      fullPath: '/stock/inventaires/'
      preLoaderRoute: typeof AppStockInventairesIndexRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/emplacements/': {
      id: '/_app/stock/emplacements/'
      path: '/'
      fullPath: '/stock/emplacements/'
      preLoaderRoute: typeof AppStockEmplacementsIndexRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/consultation/': {
      id: '/_app/stock/consultation/'
      path: '/'
      fullPath: '/stock/consultation/'
      preLoaderRoute: typeof AppStockConsultationIndexRouteImport
      parentRoute: typeof AppStockConsultationRouteRoute
    }
    '/_app/rh/planning/': {
      id: '/_app/rh/planning/'
      path: '/'
      fullPath: '/rh/planning/'
      preLoaderRoute: typeof AppRhPlanningIndexRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/notes-de-frais/': {
      id: '/_app/rh/notes-de-frais/'
      path: '/notes-de-frais'
      fullPath: '/rh/notes-de-frais/'
      preLoaderRoute: typeof AppRhNotesDeFraisIndexRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/feuilles-de-temps/': {
      id: '/_app/rh/feuilles-de-temps/'
      path: '/'
      fullPath: '/rh/feuilles-de-temps/'
      preLoaderRoute: typeof AppRhFeuillesDeTempsIndexRouteImport
      parentRoute: typeof AppRhFeuillesDeTempsRouteRoute
    }
    '/_app/rh/documents/': {
      id: '/_app/rh/documents/'
      path: '/'
      fullPath: '/rh/documents/'
      preLoaderRoute: typeof AppRhDocumentsIndexRouteImport
      parentRoute: typeof AppRhDocumentsRouteRoute
    }
    '/_app/rh/contrats/': {
      id: '/_app/rh/contrats/'
      path: '/'
      fullPath: '/rh/contrats/'
      preLoaderRoute: typeof AppRhContratsIndexRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/conges/': {
      id: '/_app/rh/conges/'
      path: '/'
      fullPath: '/rh/conges/'
      preLoaderRoute: typeof AppRhCongesIndexRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/competences/': {
      id: '/_app/rh/competences/'
      path: '/'
      fullPath: '/rh/competences/'
      preLoaderRoute: typeof AppRhCompetencesIndexRouteImport
      parentRoute: typeof AppRhCompetencesRouteRoute
    }
    '/_app/rh/collaborateurs/': {
      id: '/_app/rh/collaborateurs/'
      path: '/'
      fullPath: '/rh/collaborateurs/'
      preLoaderRoute: typeof AppRhCollaborateursIndexRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/creation/univers-commerciaux/': {
      id: '/_app/creation/univers-commerciaux/'
      path: '/'
      fullPath: '/creation/univers-commerciaux/'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIndexRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/prestations/': {
      id: '/_app/creation/prestations/'
      path: '/'
      fullPath: '/creation/prestations/'
      preLoaderRoute: typeof AppCreationPrestationsIndexRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/postes/': {
      id: '/_app/creation/postes/'
      path: '/'
      fullPath: '/creation/postes/'
      preLoaderRoute: typeof AppCreationPostesIndexRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/ldf/': {
      id: '/_app/creation/ldf/'
      path: '/'
      fullPath: '/creation/ldf/'
      preLoaderRoute: typeof AppCreationLdfIndexRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/familleArticles/': {
      id: '/_app/creation/familleArticles/'
      path: '/'
      fullPath: '/creation/familleArticles/'
      preLoaderRoute: typeof AppCreationFamilleArticlesIndexRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/dossier-techniques/': {
      id: '/_app/creation/dossier-techniques/'
      path: '/'
      fullPath: '/creation/dossier-techniques/'
      preLoaderRoute: typeof AppCreationDossierTechniquesIndexRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/ateliers/': {
      id: '/_app/creation/ateliers/'
      path: '/'
      fullPath: '/creation/ateliers/'
      preLoaderRoute: typeof AppCreationAteliersIndexRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/articles/': {
      id: '/_app/creation/articles/'
      path: '/'
      fullPath: '/creation/articles/'
      preLoaderRoute: typeof AppCreationArticlesIndexRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/achats/receptions/': {
      id: '/_app/achats/receptions/'
      path: '/receptions'
      fullPath: '/achats/receptions/'
      preLoaderRoute: typeof AppAchatsReceptionsIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournitures/': {
      id: '/_app/achats/fournitures/'
      path: '/fournitures'
      fullPath: '/achats/fournitures/'
      preLoaderRoute: typeof AppAchatsFournituresIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/fournisseurs/': {
      id: '/_app/achats/fournisseurs/'
      path: '/fournisseurs'
      fullPath: '/achats/fournisseurs/'
      preLoaderRoute: typeof AppAchatsFournisseursIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/factures/': {
      id: '/_app/achats/factures/'
      path: '/factures'
      fullPath: '/achats/factures/'
      preLoaderRoute: typeof AppAchatsFacturesIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/achats/commandes/': {
      id: '/_app/achats/commandes/'
      path: '/commandes'
      fullPath: '/achats/commandes/'
      preLoaderRoute: typeof AppAchatsCommandesIndexRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/(dashboard)/profile/': {
      id: '/_app/(dashboard)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppdashboardProfileIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/mes-conges/': {
      id: '/_app/(dashboard)/mes-conges/'
      path: '/mes-conges'
      fullPath: '/mes-conges/'
      preLoaderRoute: typeof AppdashboardMesCongesIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/': {
      id: '/_app/(dashboard)/frais/'
      path: '/frais'
      fullPath: '/frais/'
      preLoaderRoute: typeof AppdashboardFraisIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/stock/mouvements/create': {
      id: '/_app/stock/mouvements/create'
      path: '/create'
      fullPath: '/stock/mouvements/create'
      preLoaderRoute: typeof AppStockMouvementsCreateRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/inventaires/create': {
      id: '/_app/stock/inventaires/create'
      path: '/create'
      fullPath: '/stock/inventaires/create'
      preLoaderRoute: typeof AppStockInventairesCreateRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/emplacements/create': {
      id: '/_app/stock/emplacements/create'
      path: '/create'
      fullPath: '/stock/emplacements/create'
      preLoaderRoute: typeof AppStockEmplacementsCreateRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/depots/create': {
      id: '/_app/stock/depots/create'
      path: '/create'
      fullPath: '/stock/depots/create'
      preLoaderRoute: typeof AppStockDepotsCreateRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/rh/planning/create': {
      id: '/_app/rh/planning/create'
      path: '/create'
      fullPath: '/rh/planning/create'
      preLoaderRoute: typeof AppRhPlanningCreateRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/notes-de-frais/create': {
      id: '/_app/rh/notes-de-frais/create'
      path: '/notes-de-frais/create'
      fullPath: '/rh/notes-de-frais/create'
      preLoaderRoute: typeof AppRhNotesDeFraisCreateRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/contrats/create': {
      id: '/_app/rh/contrats/create'
      path: '/create'
      fullPath: '/rh/contrats/create'
      preLoaderRoute: typeof AppRhContratsCreateRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/conges/create': {
      id: '/_app/rh/conges/create'
      path: '/create'
      fullPath: '/rh/conges/create'
      preLoaderRoute: typeof AppRhCongesCreateRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/collaborateurs/create': {
      id: '/_app/rh/collaborateurs/create'
      path: '/create'
      fullPath: '/rh/collaborateurs/create'
      preLoaderRoute: typeof AppRhCollaborateursCreateRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/creation/univers-commerciaux/create': {
      id: '/_app/creation/univers-commerciaux/create'
      path: '/create'
      fullPath: '/creation/univers-commerciaux/create'
      preLoaderRoute: typeof AppCreationUniversCommerciauxCreateRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/prestations/create': {
      id: '/_app/creation/prestations/create'
      path: '/create'
      fullPath: '/creation/prestations/create'
      preLoaderRoute: typeof AppCreationPrestationsCreateRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/postes/create': {
      id: '/_app/creation/postes/create'
      path: '/create'
      fullPath: '/creation/postes/create'
      preLoaderRoute: typeof AppCreationPostesCreateRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/ldf/create': {
      id: '/_app/creation/ldf/create'
      path: '/create'
      fullPath: '/creation/ldf/create'
      preLoaderRoute: typeof AppCreationLdfCreateRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/familleArticles/create': {
      id: '/_app/creation/familleArticles/create'
      path: '/create'
      fullPath: '/creation/familleArticles/create'
      preLoaderRoute: typeof AppCreationFamilleArticlesCreateRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/dossier-techniques/create': {
      id: '/_app/creation/dossier-techniques/create'
      path: '/create'
      fullPath: '/creation/dossier-techniques/create'
      preLoaderRoute: typeof AppCreationDossierTechniquesCreateRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/ateliers/create': {
      id: '/_app/creation/ateliers/create'
      path: '/create'
      fullPath: '/creation/ateliers/create'
      preLoaderRoute: typeof AppCreationAteliersCreateRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/articles/create': {
      id: '/_app/creation/articles/create'
      path: '/create'
      fullPath: '/creation/articles/create'
      preLoaderRoute: typeof AppCreationArticlesCreateRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/(dashboard)/frais/create': {
      id: '/_app/(dashboard)/frais/create'
      path: '/frais/create'
      fullPath: '/frais/create'
      preLoaderRoute: typeof AppdashboardFraisCreateRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/rh/collaborateurs/$id/': {
      id: '/_app/rh/collaborateurs/$id/'
      path: '/$id'
      fullPath: '/rh/collaborateurs/$id/'
      preLoaderRoute: typeof AppRhCollaborateursIdIndexRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/(dashboard)/pointage/me/': {
      id: '/_app/(dashboard)/pointage/me/'
      path: '/pointage/me'
      fullPath: '/pointage/me/'
      preLoaderRoute: typeof AppdashboardPointageMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/planning/me/': {
      id: '/_app/(dashboard)/planning/me/'
      path: '/planning/me'
      fullPath: '/planning/me/'
      preLoaderRoute: typeof AppdashboardPlanningMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/me/': {
      id: '/_app/(dashboard)/frais/me/'
      path: '/frais/me'
      fullPath: '/frais/me/'
      preLoaderRoute: typeof AppdashboardFraisMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/documents/me/': {
      id: '/_app/(dashboard)/documents/me/'
      path: '/documents/me'
      fullPath: '/documents/me/'
      preLoaderRoute: typeof AppdashboardDocumentsMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/contrats/me/': {
      id: '/_app/(dashboard)/contrats/me/'
      path: '/contrats/me'
      fullPath: '/contrats/me/'
      preLoaderRoute: typeof AppdashboardContratsMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/conges/me/': {
      id: '/_app/(dashboard)/conges/me/'
      path: '/conges/me'
      fullPath: '/conges/me/'
      preLoaderRoute: typeof AppdashboardCongesMeIndexRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/stock/mouvements/$id/view': {
      id: '/_app/stock/mouvements/$id/view'
      path: '/$id/view'
      fullPath: '/stock/mouvements/$id/view'
      preLoaderRoute: typeof AppStockMouvementsIdViewRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/mouvements/$id/edit': {
      id: '/_app/stock/mouvements/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/mouvements/$id/edit'
      preLoaderRoute: typeof AppStockMouvementsIdEditRouteImport
      parentRoute: typeof AppStockMouvementsRouteRoute
    }
    '/_app/stock/inventaires/$id/view': {
      id: '/_app/stock/inventaires/$id/view'
      path: '/$id/view'
      fullPath: '/stock/inventaires/$id/view'
      preLoaderRoute: typeof AppStockInventairesIdViewRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/inventaires/$id/edit': {
      id: '/_app/stock/inventaires/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/inventaires/$id/edit'
      preLoaderRoute: typeof AppStockInventairesIdEditRouteImport
      parentRoute: typeof AppStockInventairesRouteRoute
    }
    '/_app/stock/emplacements/$id/view': {
      id: '/_app/stock/emplacements/$id/view'
      path: '/$id/view'
      fullPath: '/stock/emplacements/$id/view'
      preLoaderRoute: typeof AppStockEmplacementsIdViewRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/emplacements/$id/edit': {
      id: '/_app/stock/emplacements/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/emplacements/$id/edit'
      preLoaderRoute: typeof AppStockEmplacementsIdEditRouteImport
      parentRoute: typeof AppStockEmplacementsRouteRoute
    }
    '/_app/stock/depots/$id/view': {
      id: '/_app/stock/depots/$id/view'
      path: '/$id/view'
      fullPath: '/stock/depots/$id/view'
      preLoaderRoute: typeof AppStockDepotsIdViewRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/stock/depots/$id/edit': {
      id: '/_app/stock/depots/$id/edit'
      path: '/$id/edit'
      fullPath: '/stock/depots/$id/edit'
      preLoaderRoute: typeof AppStockDepotsIdEditRouteImport
      parentRoute: typeof AppStockDepotsRouteRoute
    }
    '/_app/rh/planning/$id/view': {
      id: '/_app/rh/planning/$id/view'
      path: '/$id/view'
      fullPath: '/rh/planning/$id/view'
      preLoaderRoute: typeof AppRhPlanningIdViewRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/planning/$id/edit': {
      id: '/_app/rh/planning/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/planning/$id/edit'
      preLoaderRoute: typeof AppRhPlanningIdEditRouteImport
      parentRoute: typeof AppRhPlanningRouteRoute
    }
    '/_app/rh/notes-de-frais/$id/view': {
      id: '/_app/rh/notes-de-frais/$id/view'
      path: '/notes-de-frais/$id/view'
      fullPath: '/rh/notes-de-frais/$id/view'
      preLoaderRoute: typeof AppRhNotesDeFraisIdViewRouteImport
      parentRoute: typeof AppRhRouteRoute
    }
    '/_app/rh/contrats/$id/view': {
      id: '/_app/rh/contrats/$id/view'
      path: '/$id/view'
      fullPath: '/rh/contrats/$id/view'
      preLoaderRoute: typeof AppRhContratsIdViewRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/contrats/$id/edit': {
      id: '/_app/rh/contrats/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/contrats/$id/edit'
      preLoaderRoute: typeof AppRhContratsIdEditRouteImport
      parentRoute: typeof AppRhContratsRouteRoute
    }
    '/_app/rh/conges/demandes/new': {
      id: '/_app/rh/conges/demandes/new'
      path: '/demandes/new'
      fullPath: '/rh/conges/demandes/new'
      preLoaderRoute: typeof AppRhCongesDemandesNewRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/conges/$id/view': {
      id: '/_app/rh/conges/$id/view'
      path: '/$id/view'
      fullPath: '/rh/conges/$id/view'
      preLoaderRoute: typeof AppRhCongesIdViewRouteImport
      parentRoute: typeof AppRhCongesRouteRoute
    }
    '/_app/rh/collaborateurs/$id/edit': {
      id: '/_app/rh/collaborateurs/$id/edit'
      path: '/$id/edit'
      fullPath: '/rh/collaborateurs/$id/edit'
      preLoaderRoute: typeof AppRhCollaborateursIdEditRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
    '/_app/creation/univers-commerciaux/$id/view': {
      id: '/_app/creation/univers-commerciaux/$id/view'
      path: '/$id/view'
      fullPath: '/creation/univers-commerciaux/$id/view'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIdViewRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/univers-commerciaux/$id/edit': {
      id: '/_app/creation/univers-commerciaux/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/univers-commerciaux/$id/edit'
      preLoaderRoute: typeof AppCreationUniversCommerciauxIdEditRouteImport
      parentRoute: typeof AppCreationUniversCommerciauxRouteRoute
    }
    '/_app/creation/prestations/$id/view': {
      id: '/_app/creation/prestations/$id/view'
      path: '/$id/view'
      fullPath: '/creation/prestations/$id/view'
      preLoaderRoute: typeof AppCreationPrestationsIdViewRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/prestations/$id/edit': {
      id: '/_app/creation/prestations/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/prestations/$id/edit'
      preLoaderRoute: typeof AppCreationPrestationsIdEditRouteImport
      parentRoute: typeof AppCreationPrestationsRouteRoute
    }
    '/_app/creation/postes/$id/view': {
      id: '/_app/creation/postes/$id/view'
      path: '/$id/view'
      fullPath: '/creation/postes/$id/view'
      preLoaderRoute: typeof AppCreationPostesIdViewRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/postes/$id/edit': {
      id: '/_app/creation/postes/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/postes/$id/edit'
      preLoaderRoute: typeof AppCreationPostesIdEditRouteImport
      parentRoute: typeof AppCreationPostesRouteRoute
    }
    '/_app/creation/ldf/$id/view': {
      id: '/_app/creation/ldf/$id/view'
      path: '/$id/view'
      fullPath: '/creation/ldf/$id/view'
      preLoaderRoute: typeof AppCreationLdfIdViewRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/ldf/$id/edit': {
      id: '/_app/creation/ldf/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/ldf/$id/edit'
      preLoaderRoute: typeof AppCreationLdfIdEditRouteImport
      parentRoute: typeof AppCreationLdfRouteRoute
    }
    '/_app/creation/familleArticles/$id/view': {
      id: '/_app/creation/familleArticles/$id/view'
      path: '/$id/view'
      fullPath: '/creation/familleArticles/$id/view'
      preLoaderRoute: typeof AppCreationFamilleArticlesIdViewRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/familleArticles/$id/edit': {
      id: '/_app/creation/familleArticles/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/familleArticles/$id/edit'
      preLoaderRoute: typeof AppCreationFamilleArticlesIdEditRouteImport
      parentRoute: typeof AppCreationFamilleArticlesRouteRoute
    }
    '/_app/creation/dossier-techniques/$id/view': {
      id: '/_app/creation/dossier-techniques/$id/view'
      path: '/$id/view'
      fullPath: '/creation/dossier-techniques/$id/view'
      preLoaderRoute: typeof AppCreationDossierTechniquesIdViewRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/dossier-techniques/$id/edit': {
      id: '/_app/creation/dossier-techniques/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/dossier-techniques/$id/edit'
      preLoaderRoute: typeof AppCreationDossierTechniquesIdEditRouteImport
      parentRoute: typeof AppCreationDossierTechniquesRouteRoute
    }
    '/_app/creation/ateliers/$id/view': {
      id: '/_app/creation/ateliers/$id/view'
      path: '/$id/view'
      fullPath: '/creation/ateliers/$id/view'
      preLoaderRoute: typeof AppCreationAteliersIdViewRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/ateliers/$id/edit': {
      id: '/_app/creation/ateliers/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/ateliers/$id/edit'
      preLoaderRoute: typeof AppCreationAteliersIdEditRouteImport
      parentRoute: typeof AppCreationAteliersRouteRoute
    }
    '/_app/creation/articles/$id/view': {
      id: '/_app/creation/articles/$id/view'
      path: '/$id/view'
      fullPath: '/creation/articles/$id/view'
      preLoaderRoute: typeof AppCreationArticlesIdViewRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/creation/articles/$id/edit': {
      id: '/_app/creation/articles/$id/edit'
      path: '/$id/edit'
      fullPath: '/creation/articles/$id/edit'
      preLoaderRoute: typeof AppCreationArticlesIdEditRouteImport
      parentRoute: typeof AppCreationArticlesRouteRoute
    }
    '/_app/achats/fournisseurs/$id/view': {
      id: '/_app/achats/fournisseurs/$id/view'
      path: '/fournisseurs/$id/view'
      fullPath: '/achats/fournisseurs/$id/view'
      preLoaderRoute: typeof AppAchatsFournisseursIdViewRouteImport
      parentRoute: typeof AppAchatsRouteRoute
    }
    '/_app/(dashboard)/frais/$id/view': {
      id: '/_app/(dashboard)/frais/$id/view'
      path: '/frais/$id/view'
      fullPath: '/frais/$id/view'
      preLoaderRoute: typeof AppdashboardFraisIdViewRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/(dashboard)/frais/$id/edit': {
      id: '/_app/(dashboard)/frais/$id/edit'
      path: '/frais/$id/edit'
      fullPath: '/frais/$id/edit'
      preLoaderRoute: typeof AppdashboardFraisIdEditRouteImport
      parentRoute: typeof AppdashboardRouteRoute
    }
    '/_app/rh/collaborateurs/$id/view': {
      id: '/_app/rh/collaborateurs/$id/view'
      path: '/$id/view'
      fullPath: '/rh/collaborateurs/$id/view'
      preLoaderRoute: typeof AppRhCollaborateursIdViewRouteRouteImport
      parentRoute: typeof AppRhCollaborateursRouteRoute
    }
  }
}

interface AppdashboardRouteRouteChildren {
  AppdashboardIndexRoute: typeof AppdashboardIndexRoute
  AppdashboardFraisCreateRoute: typeof AppdashboardFraisCreateRoute
  AppdashboardFraisIndexRoute: typeof AppdashboardFraisIndexRoute
  AppdashboardMesCongesIndexRoute: typeof AppdashboardMesCongesIndexRoute
  AppdashboardProfileIndexRoute: typeof AppdashboardProfileIndexRoute
  AppdashboardFraisIdEditRoute: typeof AppdashboardFraisIdEditRoute
  AppdashboardFraisIdViewRoute: typeof AppdashboardFraisIdViewRoute
  AppdashboardCongesMeIndexRoute: typeof AppdashboardCongesMeIndexRoute
  AppdashboardContratsMeIndexRoute: typeof AppdashboardContratsMeIndexRoute
  AppdashboardDocumentsMeIndexRoute: typeof AppdashboardDocumentsMeIndexRoute
  AppdashboardFraisMeIndexRoute: typeof AppdashboardFraisMeIndexRoute
  AppdashboardPlanningMeIndexRoute: typeof AppdashboardPlanningMeIndexRoute
  AppdashboardPointageMeIndexRoute: typeof AppdashboardPointageMeIndexRoute
}

const AppdashboardRouteRouteChildren: AppdashboardRouteRouteChildren = {
  AppdashboardIndexRoute: AppdashboardIndexRoute,
  AppdashboardFraisCreateRoute: AppdashboardFraisCreateRoute,
  AppdashboardFraisIndexRoute: AppdashboardFraisIndexRoute,
  AppdashboardMesCongesIndexRoute: AppdashboardMesCongesIndexRoute,
  AppdashboardProfileIndexRoute: AppdashboardProfileIndexRoute,
  AppdashboardFraisIdEditRoute: AppdashboardFraisIdEditRoute,
  AppdashboardFraisIdViewRoute: AppdashboardFraisIdViewRoute,
  AppdashboardCongesMeIndexRoute: AppdashboardCongesMeIndexRoute,
  AppdashboardContratsMeIndexRoute: AppdashboardContratsMeIndexRoute,
  AppdashboardDocumentsMeIndexRoute: AppdashboardDocumentsMeIndexRoute,
  AppdashboardFraisMeIndexRoute: AppdashboardFraisMeIndexRoute,
  AppdashboardPlanningMeIndexRoute: AppdashboardPlanningMeIndexRoute,
  AppdashboardPointageMeIndexRoute: AppdashboardPointageMeIndexRoute,
}

const AppdashboardRouteRouteWithChildren =
  AppdashboardRouteRoute._addFileChildren(AppdashboardRouteRouteChildren)

interface AppAchatsRouteRouteChildren {
  AppAchatsIndexRoute: typeof AppAchatsIndexRoute
  AppAchatsCommandesIndexRoute: typeof AppAchatsCommandesIndexRoute
  AppAchatsFacturesIndexRoute: typeof AppAchatsFacturesIndexRoute
  AppAchatsFournisseursIndexRoute: typeof AppAchatsFournisseursIndexRoute
  AppAchatsFournituresIndexRoute: typeof AppAchatsFournituresIndexRoute
  AppAchatsReceptionsIndexRoute: typeof AppAchatsReceptionsIndexRoute
  AppAchatsFournisseursIdViewRoute: typeof AppAchatsFournisseursIdViewRoute
}

const AppAchatsRouteRouteChildren: AppAchatsRouteRouteChildren = {
  AppAchatsIndexRoute: AppAchatsIndexRoute,
  AppAchatsCommandesIndexRoute: AppAchatsCommandesIndexRoute,
  AppAchatsFacturesIndexRoute: AppAchatsFacturesIndexRoute,
  AppAchatsFournisseursIndexRoute: AppAchatsFournisseursIndexRoute,
  AppAchatsFournituresIndexRoute: AppAchatsFournituresIndexRoute,
  AppAchatsReceptionsIndexRoute: AppAchatsReceptionsIndexRoute,
  AppAchatsFournisseursIdViewRoute: AppAchatsFournisseursIdViewRoute,
}

const AppAchatsRouteRouteWithChildren = AppAchatsRouteRoute._addFileChildren(
  AppAchatsRouteRouteChildren,
)

interface AppCreationArticlesRouteRouteChildren {
  AppCreationArticlesCreateRoute: typeof AppCreationArticlesCreateRoute
  AppCreationArticlesIndexRoute: typeof AppCreationArticlesIndexRoute
  AppCreationArticlesIdEditRoute: typeof AppCreationArticlesIdEditRoute
  AppCreationArticlesIdViewRoute: typeof AppCreationArticlesIdViewRoute
}

const AppCreationArticlesRouteRouteChildren: AppCreationArticlesRouteRouteChildren =
  {
    AppCreationArticlesCreateRoute: AppCreationArticlesCreateRoute,
    AppCreationArticlesIndexRoute: AppCreationArticlesIndexRoute,
    AppCreationArticlesIdEditRoute: AppCreationArticlesIdEditRoute,
    AppCreationArticlesIdViewRoute: AppCreationArticlesIdViewRoute,
  }

const AppCreationArticlesRouteRouteWithChildren =
  AppCreationArticlesRouteRoute._addFileChildren(
    AppCreationArticlesRouteRouteChildren,
  )

interface AppCreationAteliersRouteRouteChildren {
  AppCreationAteliersCreateRoute: typeof AppCreationAteliersCreateRoute
  AppCreationAteliersIndexRoute: typeof AppCreationAteliersIndexRoute
  AppCreationAteliersIdEditRoute: typeof AppCreationAteliersIdEditRoute
  AppCreationAteliersIdViewRoute: typeof AppCreationAteliersIdViewRoute
}

const AppCreationAteliersRouteRouteChildren: AppCreationAteliersRouteRouteChildren =
  {
    AppCreationAteliersCreateRoute: AppCreationAteliersCreateRoute,
    AppCreationAteliersIndexRoute: AppCreationAteliersIndexRoute,
    AppCreationAteliersIdEditRoute: AppCreationAteliersIdEditRoute,
    AppCreationAteliersIdViewRoute: AppCreationAteliersIdViewRoute,
  }

const AppCreationAteliersRouteRouteWithChildren =
  AppCreationAteliersRouteRoute._addFileChildren(
    AppCreationAteliersRouteRouteChildren,
  )

interface AppCreationDossierTechniquesRouteRouteChildren {
  AppCreationDossierTechniquesCreateRoute: typeof AppCreationDossierTechniquesCreateRoute
  AppCreationDossierTechniquesIndexRoute: typeof AppCreationDossierTechniquesIndexRoute
  AppCreationDossierTechniquesIdEditRoute: typeof AppCreationDossierTechniquesIdEditRoute
  AppCreationDossierTechniquesIdViewRoute: typeof AppCreationDossierTechniquesIdViewRoute
}

const AppCreationDossierTechniquesRouteRouteChildren: AppCreationDossierTechniquesRouteRouteChildren =
  {
    AppCreationDossierTechniquesCreateRoute:
      AppCreationDossierTechniquesCreateRoute,
    AppCreationDossierTechniquesIndexRoute:
      AppCreationDossierTechniquesIndexRoute,
    AppCreationDossierTechniquesIdEditRoute:
      AppCreationDossierTechniquesIdEditRoute,
    AppCreationDossierTechniquesIdViewRoute:
      AppCreationDossierTechniquesIdViewRoute,
  }

const AppCreationDossierTechniquesRouteRouteWithChildren =
  AppCreationDossierTechniquesRouteRoute._addFileChildren(
    AppCreationDossierTechniquesRouteRouteChildren,
  )

interface AppCreationFamilleArticlesRouteRouteChildren {
  AppCreationFamilleArticlesCreateRoute: typeof AppCreationFamilleArticlesCreateRoute
  AppCreationFamilleArticlesIndexRoute: typeof AppCreationFamilleArticlesIndexRoute
  AppCreationFamilleArticlesIdEditRoute: typeof AppCreationFamilleArticlesIdEditRoute
  AppCreationFamilleArticlesIdViewRoute: typeof AppCreationFamilleArticlesIdViewRoute
}

const AppCreationFamilleArticlesRouteRouteChildren: AppCreationFamilleArticlesRouteRouteChildren =
  {
    AppCreationFamilleArticlesCreateRoute:
      AppCreationFamilleArticlesCreateRoute,
    AppCreationFamilleArticlesIndexRoute: AppCreationFamilleArticlesIndexRoute,
    AppCreationFamilleArticlesIdEditRoute:
      AppCreationFamilleArticlesIdEditRoute,
    AppCreationFamilleArticlesIdViewRoute:
      AppCreationFamilleArticlesIdViewRoute,
  }

const AppCreationFamilleArticlesRouteRouteWithChildren =
  AppCreationFamilleArticlesRouteRoute._addFileChildren(
    AppCreationFamilleArticlesRouteRouteChildren,
  )

interface AppCreationLdfRouteRouteChildren {
  AppCreationLdfCreateRoute: typeof AppCreationLdfCreateRoute
  AppCreationLdfIndexRoute: typeof AppCreationLdfIndexRoute
  AppCreationLdfIdEditRoute: typeof AppCreationLdfIdEditRoute
  AppCreationLdfIdViewRoute: typeof AppCreationLdfIdViewRoute
}

const AppCreationLdfRouteRouteChildren: AppCreationLdfRouteRouteChildren = {
  AppCreationLdfCreateRoute: AppCreationLdfCreateRoute,
  AppCreationLdfIndexRoute: AppCreationLdfIndexRoute,
  AppCreationLdfIdEditRoute: AppCreationLdfIdEditRoute,
  AppCreationLdfIdViewRoute: AppCreationLdfIdViewRoute,
}

const AppCreationLdfRouteRouteWithChildren =
  AppCreationLdfRouteRoute._addFileChildren(AppCreationLdfRouteRouteChildren)

interface AppCreationPostesRouteRouteChildren {
  AppCreationPostesCreateRoute: typeof AppCreationPostesCreateRoute
  AppCreationPostesIndexRoute: typeof AppCreationPostesIndexRoute
  AppCreationPostesIdEditRoute: typeof AppCreationPostesIdEditRoute
  AppCreationPostesIdViewRoute: typeof AppCreationPostesIdViewRoute
}

const AppCreationPostesRouteRouteChildren: AppCreationPostesRouteRouteChildren =
  {
    AppCreationPostesCreateRoute: AppCreationPostesCreateRoute,
    AppCreationPostesIndexRoute: AppCreationPostesIndexRoute,
    AppCreationPostesIdEditRoute: AppCreationPostesIdEditRoute,
    AppCreationPostesIdViewRoute: AppCreationPostesIdViewRoute,
  }

const AppCreationPostesRouteRouteWithChildren =
  AppCreationPostesRouteRoute._addFileChildren(
    AppCreationPostesRouteRouteChildren,
  )

interface AppCreationPrestationsRouteRouteChildren {
  AppCreationPrestationsCreateRoute: typeof AppCreationPrestationsCreateRoute
  AppCreationPrestationsIndexRoute: typeof AppCreationPrestationsIndexRoute
  AppCreationPrestationsIdEditRoute: typeof AppCreationPrestationsIdEditRoute
  AppCreationPrestationsIdViewRoute: typeof AppCreationPrestationsIdViewRoute
}

const AppCreationPrestationsRouteRouteChildren: AppCreationPrestationsRouteRouteChildren =
  {
    AppCreationPrestationsCreateRoute: AppCreationPrestationsCreateRoute,
    AppCreationPrestationsIndexRoute: AppCreationPrestationsIndexRoute,
    AppCreationPrestationsIdEditRoute: AppCreationPrestationsIdEditRoute,
    AppCreationPrestationsIdViewRoute: AppCreationPrestationsIdViewRoute,
  }

const AppCreationPrestationsRouteRouteWithChildren =
  AppCreationPrestationsRouteRoute._addFileChildren(
    AppCreationPrestationsRouteRouteChildren,
  )

interface AppCreationUniversCommerciauxRouteRouteChildren {
  AppCreationUniversCommerciauxCreateRoute: typeof AppCreationUniversCommerciauxCreateRoute
  AppCreationUniversCommerciauxIndexRoute: typeof AppCreationUniversCommerciauxIndexRoute
  AppCreationUniversCommerciauxIdEditRoute: typeof AppCreationUniversCommerciauxIdEditRoute
  AppCreationUniversCommerciauxIdViewRoute: typeof AppCreationUniversCommerciauxIdViewRoute
}

const AppCreationUniversCommerciauxRouteRouteChildren: AppCreationUniversCommerciauxRouteRouteChildren =
  {
    AppCreationUniversCommerciauxCreateRoute:
      AppCreationUniversCommerciauxCreateRoute,
    AppCreationUniversCommerciauxIndexRoute:
      AppCreationUniversCommerciauxIndexRoute,
    AppCreationUniversCommerciauxIdEditRoute:
      AppCreationUniversCommerciauxIdEditRoute,
    AppCreationUniversCommerciauxIdViewRoute:
      AppCreationUniversCommerciauxIdViewRoute,
  }

const AppCreationUniversCommerciauxRouteRouteWithChildren =
  AppCreationUniversCommerciauxRouteRoute._addFileChildren(
    AppCreationUniversCommerciauxRouteRouteChildren,
  )

interface AppCreationRouteRouteChildren {
  AppCreationArticlesRouteRoute: typeof AppCreationArticlesRouteRouteWithChildren
  AppCreationAteliersRouteRoute: typeof AppCreationAteliersRouteRouteWithChildren
  AppCreationDossierTechniquesRouteRoute: typeof AppCreationDossierTechniquesRouteRouteWithChildren
  AppCreationFamilleArticlesRouteRoute: typeof AppCreationFamilleArticlesRouteRouteWithChildren
  AppCreationLdfRouteRoute: typeof AppCreationLdfRouteRouteWithChildren
  AppCreationPostesRouteRoute: typeof AppCreationPostesRouteRouteWithChildren
  AppCreationPrestationsRouteRoute: typeof AppCreationPrestationsRouteRouteWithChildren
  AppCreationUniversCommerciauxRouteRoute: typeof AppCreationUniversCommerciauxRouteRouteWithChildren
  AppCreationIndexRoute: typeof AppCreationIndexRoute
}

const AppCreationRouteRouteChildren: AppCreationRouteRouteChildren = {
  AppCreationArticlesRouteRoute: AppCreationArticlesRouteRouteWithChildren,
  AppCreationAteliersRouteRoute: AppCreationAteliersRouteRouteWithChildren,
  AppCreationDossierTechniquesRouteRoute:
    AppCreationDossierTechniquesRouteRouteWithChildren,
  AppCreationFamilleArticlesRouteRoute:
    AppCreationFamilleArticlesRouteRouteWithChildren,
  AppCreationLdfRouteRoute: AppCreationLdfRouteRouteWithChildren,
  AppCreationPostesRouteRoute: AppCreationPostesRouteRouteWithChildren,
  AppCreationPrestationsRouteRoute:
    AppCreationPrestationsRouteRouteWithChildren,
  AppCreationUniversCommerciauxRouteRoute:
    AppCreationUniversCommerciauxRouteRouteWithChildren,
  AppCreationIndexRoute: AppCreationIndexRoute,
}

const AppCreationRouteRouteWithChildren =
  AppCreationRouteRoute._addFileChildren(AppCreationRouteRouteChildren)

interface AppRhCollaborateursRouteRouteChildren {
  AppRhCollaborateursCreateRoute: typeof AppRhCollaborateursCreateRoute
  AppRhCollaborateursIndexRoute: typeof AppRhCollaborateursIndexRoute
  AppRhCollaborateursIdViewRouteRoute: typeof AppRhCollaborateursIdViewRouteRoute
  AppRhCollaborateursIdEditRoute: typeof AppRhCollaborateursIdEditRoute
  AppRhCollaborateursIdIndexRoute: typeof AppRhCollaborateursIdIndexRoute
}

const AppRhCollaborateursRouteRouteChildren: AppRhCollaborateursRouteRouteChildren =
  {
    AppRhCollaborateursCreateRoute: AppRhCollaborateursCreateRoute,
    AppRhCollaborateursIndexRoute: AppRhCollaborateursIndexRoute,
    AppRhCollaborateursIdViewRouteRoute: AppRhCollaborateursIdViewRouteRoute,
    AppRhCollaborateursIdEditRoute: AppRhCollaborateursIdEditRoute,
    AppRhCollaborateursIdIndexRoute: AppRhCollaborateursIdIndexRoute,
  }

const AppRhCollaborateursRouteRouteWithChildren =
  AppRhCollaborateursRouteRoute._addFileChildren(
    AppRhCollaborateursRouteRouteChildren,
  )

interface AppRhCompetencesRouteRouteChildren {
  AppRhCompetencesIndexRoute: typeof AppRhCompetencesIndexRoute
}

const AppRhCompetencesRouteRouteChildren: AppRhCompetencesRouteRouteChildren = {
  AppRhCompetencesIndexRoute: AppRhCompetencesIndexRoute,
}

const AppRhCompetencesRouteRouteWithChildren =
  AppRhCompetencesRouteRoute._addFileChildren(
    AppRhCompetencesRouteRouteChildren,
  )

interface AppRhCongesRouteRouteChildren {
  AppRhCongesCreateRoute: typeof AppRhCongesCreateRoute
  AppRhCongesIndexRoute: typeof AppRhCongesIndexRoute
  AppRhCongesIdViewRoute: typeof AppRhCongesIdViewRoute
  AppRhCongesDemandesNewRoute: typeof AppRhCongesDemandesNewRoute
}

const AppRhCongesRouteRouteChildren: AppRhCongesRouteRouteChildren = {
  AppRhCongesCreateRoute: AppRhCongesCreateRoute,
  AppRhCongesIndexRoute: AppRhCongesIndexRoute,
  AppRhCongesIdViewRoute: AppRhCongesIdViewRoute,
  AppRhCongesDemandesNewRoute: AppRhCongesDemandesNewRoute,
}

const AppRhCongesRouteRouteWithChildren =
  AppRhCongesRouteRoute._addFileChildren(AppRhCongesRouteRouteChildren)

interface AppRhContratsRouteRouteChildren {
  AppRhContratsCreateRoute: typeof AppRhContratsCreateRoute
  AppRhContratsIndexRoute: typeof AppRhContratsIndexRoute
  AppRhContratsIdEditRoute: typeof AppRhContratsIdEditRoute
  AppRhContratsIdViewRoute: typeof AppRhContratsIdViewRoute
}

const AppRhContratsRouteRouteChildren: AppRhContratsRouteRouteChildren = {
  AppRhContratsCreateRoute: AppRhContratsCreateRoute,
  AppRhContratsIndexRoute: AppRhContratsIndexRoute,
  AppRhContratsIdEditRoute: AppRhContratsIdEditRoute,
  AppRhContratsIdViewRoute: AppRhContratsIdViewRoute,
}

const AppRhContratsRouteRouteWithChildren =
  AppRhContratsRouteRoute._addFileChildren(AppRhContratsRouteRouteChildren)

interface AppRhDocumentsRouteRouteChildren {
  AppRhDocumentsIndexRoute: typeof AppRhDocumentsIndexRoute
}

const AppRhDocumentsRouteRouteChildren: AppRhDocumentsRouteRouteChildren = {
  AppRhDocumentsIndexRoute: AppRhDocumentsIndexRoute,
}

const AppRhDocumentsRouteRouteWithChildren =
  AppRhDocumentsRouteRoute._addFileChildren(AppRhDocumentsRouteRouteChildren)

interface AppRhFeuillesDeTempsRouteRouteChildren {
  AppRhFeuillesDeTempsIndexRoute: typeof AppRhFeuillesDeTempsIndexRoute
}

const AppRhFeuillesDeTempsRouteRouteChildren: AppRhFeuillesDeTempsRouteRouteChildren =
  {
    AppRhFeuillesDeTempsIndexRoute: AppRhFeuillesDeTempsIndexRoute,
  }

const AppRhFeuillesDeTempsRouteRouteWithChildren =
  AppRhFeuillesDeTempsRouteRoute._addFileChildren(
    AppRhFeuillesDeTempsRouteRouteChildren,
  )

interface AppRhPlanningRouteRouteChildren {
  AppRhPlanningCreateRoute: typeof AppRhPlanningCreateRoute
  AppRhPlanningIndexRoute: typeof AppRhPlanningIndexRoute
  AppRhPlanningIdEditRoute: typeof AppRhPlanningIdEditRoute
  AppRhPlanningIdViewRoute: typeof AppRhPlanningIdViewRoute
}

const AppRhPlanningRouteRouteChildren: AppRhPlanningRouteRouteChildren = {
  AppRhPlanningCreateRoute: AppRhPlanningCreateRoute,
  AppRhPlanningIndexRoute: AppRhPlanningIndexRoute,
  AppRhPlanningIdEditRoute: AppRhPlanningIdEditRoute,
  AppRhPlanningIdViewRoute: AppRhPlanningIdViewRoute,
}

const AppRhPlanningRouteRouteWithChildren =
  AppRhPlanningRouteRoute._addFileChildren(AppRhPlanningRouteRouteChildren)

interface AppRhRouteRouteChildren {
  AppRhCollaborateursRouteRoute: typeof AppRhCollaborateursRouteRouteWithChildren
  AppRhCompetencesRouteRoute: typeof AppRhCompetencesRouteRouteWithChildren
  AppRhCongesRouteRoute: typeof AppRhCongesRouteRouteWithChildren
  AppRhContratsRouteRoute: typeof AppRhContratsRouteRouteWithChildren
  AppRhDocumentsRouteRoute: typeof AppRhDocumentsRouteRouteWithChildren
  AppRhFeuillesDeTempsRouteRoute: typeof AppRhFeuillesDeTempsRouteRouteWithChildren
  AppRhPlanningRouteRoute: typeof AppRhPlanningRouteRouteWithChildren
  AppRhIndexRoute: typeof AppRhIndexRoute
  AppRhNotesDeFraisCreateRoute: typeof AppRhNotesDeFraisCreateRoute
  AppRhNotesDeFraisIndexRoute: typeof AppRhNotesDeFraisIndexRoute
  AppRhNotesDeFraisIdViewRoute: typeof AppRhNotesDeFraisIdViewRoute
}

const AppRhRouteRouteChildren: AppRhRouteRouteChildren = {
  AppRhCollaborateursRouteRoute: AppRhCollaborateursRouteRouteWithChildren,
  AppRhCompetencesRouteRoute: AppRhCompetencesRouteRouteWithChildren,
  AppRhCongesRouteRoute: AppRhCongesRouteRouteWithChildren,
  AppRhContratsRouteRoute: AppRhContratsRouteRouteWithChildren,
  AppRhDocumentsRouteRoute: AppRhDocumentsRouteRouteWithChildren,
  AppRhFeuillesDeTempsRouteRoute: AppRhFeuillesDeTempsRouteRouteWithChildren,
  AppRhPlanningRouteRoute: AppRhPlanningRouteRouteWithChildren,
  AppRhIndexRoute: AppRhIndexRoute,
  AppRhNotesDeFraisCreateRoute: AppRhNotesDeFraisCreateRoute,
  AppRhNotesDeFraisIndexRoute: AppRhNotesDeFraisIndexRoute,
  AppRhNotesDeFraisIdViewRoute: AppRhNotesDeFraisIdViewRoute,
}

const AppRhRouteRouteWithChildren = AppRhRouteRoute._addFileChildren(
  AppRhRouteRouteChildren,
)

interface AppStockConsultationRouteRouteChildren {
  AppStockConsultationIndexRoute: typeof AppStockConsultationIndexRoute
}

const AppStockConsultationRouteRouteChildren: AppStockConsultationRouteRouteChildren =
  {
    AppStockConsultationIndexRoute: AppStockConsultationIndexRoute,
  }

const AppStockConsultationRouteRouteWithChildren =
  AppStockConsultationRouteRoute._addFileChildren(
    AppStockConsultationRouteRouteChildren,
  )

interface AppStockDepotsRouteRouteChildren {
  AppStockDepotsCreateRoute: typeof AppStockDepotsCreateRoute
  AppStockDepotsIdEditRoute: typeof AppStockDepotsIdEditRoute
  AppStockDepotsIdViewRoute: typeof AppStockDepotsIdViewRoute
}

const AppStockDepotsRouteRouteChildren: AppStockDepotsRouteRouteChildren = {
  AppStockDepotsCreateRoute: AppStockDepotsCreateRoute,
  AppStockDepotsIdEditRoute: AppStockDepotsIdEditRoute,
  AppStockDepotsIdViewRoute: AppStockDepotsIdViewRoute,
}

const AppStockDepotsRouteRouteWithChildren =
  AppStockDepotsRouteRoute._addFileChildren(AppStockDepotsRouteRouteChildren)

interface AppStockEmplacementsRouteRouteChildren {
  AppStockEmplacementsCreateRoute: typeof AppStockEmplacementsCreateRoute
  AppStockEmplacementsIndexRoute: typeof AppStockEmplacementsIndexRoute
  AppStockEmplacementsIdEditRoute: typeof AppStockEmplacementsIdEditRoute
  AppStockEmplacementsIdViewRoute: typeof AppStockEmplacementsIdViewRoute
}

const AppStockEmplacementsRouteRouteChildren: AppStockEmplacementsRouteRouteChildren =
  {
    AppStockEmplacementsCreateRoute: AppStockEmplacementsCreateRoute,
    AppStockEmplacementsIndexRoute: AppStockEmplacementsIndexRoute,
    AppStockEmplacementsIdEditRoute: AppStockEmplacementsIdEditRoute,
    AppStockEmplacementsIdViewRoute: AppStockEmplacementsIdViewRoute,
  }

const AppStockEmplacementsRouteRouteWithChildren =
  AppStockEmplacementsRouteRoute._addFileChildren(
    AppStockEmplacementsRouteRouteChildren,
  )

interface AppStockInventairesRouteRouteChildren {
  AppStockInventairesCreateRoute: typeof AppStockInventairesCreateRoute
  AppStockInventairesIndexRoute: typeof AppStockInventairesIndexRoute
  AppStockInventairesIdEditRoute: typeof AppStockInventairesIdEditRoute
  AppStockInventairesIdViewRoute: typeof AppStockInventairesIdViewRoute
}

const AppStockInventairesRouteRouteChildren: AppStockInventairesRouteRouteChildren =
  {
    AppStockInventairesCreateRoute: AppStockInventairesCreateRoute,
    AppStockInventairesIndexRoute: AppStockInventairesIndexRoute,
    AppStockInventairesIdEditRoute: AppStockInventairesIdEditRoute,
    AppStockInventairesIdViewRoute: AppStockInventairesIdViewRoute,
  }

const AppStockInventairesRouteRouteWithChildren =
  AppStockInventairesRouteRoute._addFileChildren(
    AppStockInventairesRouteRouteChildren,
  )

interface AppStockMouvementsRouteRouteChildren {
  AppStockMouvementsCreateRoute: typeof AppStockMouvementsCreateRoute
  AppStockMouvementsIndexRoute: typeof AppStockMouvementsIndexRoute
  AppStockMouvementsIdEditRoute: typeof AppStockMouvementsIdEditRoute
  AppStockMouvementsIdViewRoute: typeof AppStockMouvementsIdViewRoute
}

const AppStockMouvementsRouteRouteChildren: AppStockMouvementsRouteRouteChildren =
  {
    AppStockMouvementsCreateRoute: AppStockMouvementsCreateRoute,
    AppStockMouvementsIndexRoute: AppStockMouvementsIndexRoute,
    AppStockMouvementsIdEditRoute: AppStockMouvementsIdEditRoute,
    AppStockMouvementsIdViewRoute: AppStockMouvementsIdViewRoute,
  }

const AppStockMouvementsRouteRouteWithChildren =
  AppStockMouvementsRouteRoute._addFileChildren(
    AppStockMouvementsRouteRouteChildren,
  )

interface AppStockRouteRouteChildren {
  AppStockConsultationRouteRoute: typeof AppStockConsultationRouteRouteWithChildren
  AppStockDepotsRouteRoute: typeof AppStockDepotsRouteRouteWithChildren
  AppStockEmplacementsRouteRoute: typeof AppStockEmplacementsRouteRouteWithChildren
  AppStockInventairesRouteRoute: typeof AppStockInventairesRouteRouteWithChildren
  AppStockMouvementsRouteRoute: typeof AppStockMouvementsRouteRouteWithChildren
  AppStockIndexRoute: typeof AppStockIndexRoute
}

const AppStockRouteRouteChildren: AppStockRouteRouteChildren = {
  AppStockConsultationRouteRoute: AppStockConsultationRouteRouteWithChildren,
  AppStockDepotsRouteRoute: AppStockDepotsRouteRouteWithChildren,
  AppStockEmplacementsRouteRoute: AppStockEmplacementsRouteRouteWithChildren,
  AppStockInventairesRouteRoute: AppStockInventairesRouteRouteWithChildren,
  AppStockMouvementsRouteRoute: AppStockMouvementsRouteRouteWithChildren,
  AppStockIndexRoute: AppStockIndexRoute,
}

const AppStockRouteRouteWithChildren = AppStockRouteRoute._addFileChildren(
  AppStockRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppdashboardRouteRoute: typeof AppdashboardRouteRouteWithChildren
  AppAchatsRouteRoute: typeof AppAchatsRouteRouteWithChildren
  AppCreationRouteRoute: typeof AppCreationRouteRouteWithChildren
  AppParametresRouteRoute: typeof AppParametresRouteRoute
  AppRhRouteRoute: typeof AppRhRouteRouteWithChildren
  AppStockRouteRoute: typeof AppStockRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppdashboardRouteRoute: AppdashboardRouteRouteWithChildren,
  AppAchatsRouteRoute: AppAchatsRouteRouteWithChildren,
  AppCreationRouteRoute: AppCreationRouteRouteWithChildren,
  AppParametresRouteRoute: AppParametresRouteRoute,
  AppRhRouteRoute: AppRhRouteRouteWithChildren,
  AppStockRouteRoute: AppStockRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetupPasswordRoute: typeof AuthSetupPasswordRoute
  AuthPointageHashRoute: typeof AuthPointageHashRoute
  AuthPointageQrCodeRoute: typeof AuthPointageQrCodeRoute
  AuthSignatureContratTokenRoute: typeof AuthSignatureContratTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSetupPasswordRoute: AuthSetupPasswordRoute,
  AuthPointageHashRoute: AuthPointageHashRoute,
  AuthPointageQrCodeRoute: AuthPointageQrCodeRoute,
  AuthSignatureContratTokenRoute: AuthSignatureContratTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  MentionsLegalesRoute: MentionsLegalesRoute,
  PolitiqueConfidentialiteRoute: PolitiqueConfidentialiteRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
